import React, { Component, Fragment } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "../../actions"
import Modal from "react-responsive-modal"
import submitData from "helpers/submitData"
import clone from "clone"
import fieldStatus from "helpers/fieldStatus"
import _ from "lodash"
import settings from "settings"
import axios from "axios"
import helpers from "helpers/helpers"
import { Formik, Field, Form } from "formik"
import DateField from "components/DateField"
import NumberField from "components/NumberField"
import ReactSelect from "components/ReactSelect"
import moment from "moment"
import Typeahead from "components/Typeahead"
import TextArea from "components/TextArea"
import HTMLEditor from "components/HTMLEditor"
import TableRowField from "components/TableRowField"
import objToFalse from "helpers/objToFalse"
import classNames from "classnames"
import { totalMarketingFee, calculateTrueUp, calculateInterest } from "helpers/lotFees"
import Dropzone from "react-dropzone"
import numeral from "numeral"
import submitDataAsync from "helpers/asyncSubmitData"
import { toast } from "react-toastify"
import {
	Accordion,
	AccordionItem,
	AccordionItemHeading,
	AccordionItemPanel,
	AccordionItemButton,
} from "react-accessible-accordion"
import request from "superagent"
import BustoutModal from "containers/entry/modals/bustout"
import ContractModal from "containers/entry/modals/contract"
import TransferModal from "containers/entry/modals/transfer"
import MoveModal from "containers/entry/modals/move"
import DeleteSale from "containers/entry/modals/deleteSale"
import RemoveClosing from "containers/entry/modals/removeClosing"
import RemoveCancel from "containers/entry/modals/removeCancel"
import ClosingModal from "containers/entry/modals/closing"
import currentUser from "helpers/currentUser"
import userToken from "helpers/userToken"
import { GridContextProvider, GridDropZone, GridItem, swap } from "react-grid-dnd"
import superagent from "superagent"
import * as fflate from "fflate"

class LotModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			ready: false,
			files: {},
			images: [],
			hide: false,
			selectedImages: [], // index of selected images for clicking multiple to push to top/bottom
			data: {
				lot: {},
				sales: [],
				buyers: [],
			},
			initial: {
				lot: {},
				sales: {},
				buyers: [],
			},
			touched: {},
			errors: {},
			transferModal: false,
			closingModal: false,
			contractModal: false,
			bustoutModal: false,
			moveModal: false,
			deleteSale: false,
			removeCancel: false,
			diffViewer: false,
			deleteSaleDetails: {},
			removeCancelDetails: {},
			removeClosing: false,
			removeClosingData: {},
			canSubmit: false,
			logModal: false,
			image_type: null,
			teams: {}, // storage for trec brokerages
			offices: {}, // storage for trec brokerages
			diffData: {
				open: null,
				against: null,
			},
			lotDocuments: [],
			isDragging: false,
		}
		this.files = {}
	}

	componentDidMount() {
		let user = currentUser()
		let lm = _.find(this.props.payload.public.loadedModules, { name: "Lot Management" })
		if (
			user &&
			user.modules &&
			!_.isEmpty(user.modules) &&
			(user.modules[0] == "*" || user.modules.includes(lm.id))
		) {
			this.setState({ canSubmit: true })
		}
	}

	componentDidUpdate(prevProps, prevState) {
		// On lot management, when you click on a filter, this was triggering the lot, thus the return here.
		if (this.props.data && _.isArray(this.props.data)) {
			return
		}
		if (prevProps.data !== this.props.data && this.props?.data?.id) {
			this.props.loadingStatus(true)
			this.determineDocs()
			this.pullLot()
		}
	}

	pullLot = async () => {
		var userToken = localStorage.getItem("user")
		//console.log(this.props.data)
		axios
			.post(settings.ep + "/getLotFull", this.props.data, {
				headers: { Authorization: `Bearer ${userToken}` },
			})
			.then((response) => {
				//console.log(response.data)

				let initial = response.data
				let touched = clone(initial)
				let errors = clone(initial)
				touched = objToFalse(touched)
				errors = objToFalse(errors)
				//response.data.lot = nullToEmptyString(response.data.lot)
				// If sales have brokerage info, move it here.
				let teams = {}
				let offices = {}
				_.forEach(initial.sales, (v, k) => {
					if (v.brokerageInfo) {
						_.setWith(teams, k, v.brokerageInfo.teams, Object)
						_.setWith(offices, k, v.brokerageInfo.offices, Object)
					}
				})
				if (!response.data.lot.takedown_date) {
					response.data.lot.const_status = ""
				} else if (response.data.lot.complete_date) {
					response.data.lot.const_status = "Complete"
				} else if (response.data.lot.start_date) {
					response.data.lot.const_status = "Slab"
				} else {
					response.data.lot.const_status = "Vacant"
				}
				if (response.data.lot.model == 1) {
					response.data.lot.sale_status = "Model"
				} else if (response.data.lot.closing_date) {
					response.data.lot.sale_status = "Closed"
				} else if (!response.data.lot.closing_date && response.data.lot.sale_id) {
					response.data.lot.sale_status = "Contract"
				} else if (response.data.lot.lot_status == "Bustout") {
					response.data.lot.sale_status = "Bustout"
				} else {
					response.data.lot.sale_status = ""
				}
				this.setState(
					{
						data: response.data,
						teams,
						offices,
						initial: initial,
						ready: true,
						touched: touched,
						errors: errors,
						images: response.data.lot.images ? _.compact(response.data.lot.images) : [],
						general_docs: response.data.lot.general_docs ? _.compact(response.data.lot.general_docs) : [],
						lotDocuments: response.data.lot.general_docs ? _.compact(response.data.lot.general_docs) : []
					},
					() => {
						//console.log(this.state)
					}
				)
				this.props.loadingStatus(false)
			})
			.catch((error) => {
				// need error handling
				this.props.loadingStatus(false)
			})
	}

	/* validation = () => {
		return Yup.object().shape({
			sales: Yup.array().of(
				Yup.object().shape({
					realtor_office: Yup.number()
						.moreThan(0, "Please choose a brokerage from the list.")
						//.typeError('Please choose a brokerage from the list.')
						.transform((value) => (isNaN(value) ? undefined : value))
						.notRequired(),
				})
			),
		})
	} */

	salespeopleList = () => {
		let ret = []
		_.filter(this.props.payload.public.salespeople, (v) => {
			if (v.builders && v.builders.includes(this.state.data.lot.builder)) {
				ret.push({
					label: `${v.first} ${v.last}`,
					value: v.id,
				})
			}
		})
		return ret
	}

	determineDocs = () => {
		let docs = _.find(this.props.payload.public.properties, { id: this.props.data.property })
		if (docs && docs.assigned_docs && docs.assigned_docs.length > 0) {
			let fields = _.filter(docs.assigned_docs, (r) => {
				if (docs.assigned_docs.includes(r)) {
					return r
				}
			})
			let ret = _.map(fields, (v) => {
				let details = _.find(this.props.payload.public.options.docs, { id: v })
				if (details) {
					details.status = false
					return details
				}
			})
			this.setState({ files: ret })
		}
	}

	handleSubmit = () => {
		let d = {
			docs: clone(this.state.documents),
			sale_id: this.props.data.id,
		}
		submitData("manageDocuments", d).then((data) => {
			let obj = {
				status: true,
				title: "Recorded",
				text: "Document(s) have been recorded.",
			}
			this.props.alert(obj)
		})
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	numChildren = () => {
		let ret = []
		for (let i = 1; i <= 10; i++) {
			ret.push({ value: i, label: i })
		}
		return ret
	}

	createOptions = (name, all) => {
		// all means it doesn't care which property this is in
		if (this.props.payload.public[name]) {
			let f = []
			_.forEach(this.props.payload.public[name], (r) => {
				if (all) {
					f.push({
						value: r.id,
						label: r.name,
					})
				} else {
					if (r.property == this.props.data.property) {
						f.push({
							value: r.id,
							label: r.name,
						})
					}
				}
			})
			return f
		}
		return []
	}

	trafficSources = () => {
		return _.map(this.props.payload.public.trafficSources, (v) => {
			return { value: v.id, label: v.name }
		})
	}

	closeModal = () => {
		// When modal is closed, clear state entirely
		this.setState(
			{
				ready: false,
				files: {},
				data: {
					lot: {},
					sales: [],
					buyers: [],
				},
				initial: {
					lot: {},
					sales: {},
					buyers: [],
				},
				touched: {},
				errors: {},
			},
			() => {
				this.props.onClose()
			}
		)
	}

	floorplans = () => {
		let ret = []
		_.forEach(this.props.payload.public.floorplans, (v) => {
			if (v.builder == this.state.data.lot.builder) {
				ret.push({
					label: v.name,
					value: v.id,
				})
			}
		})
		return ret
	}

	propertyLimited = (name) => {
		let ret = []
		_.forEach(this.props.payload.public[name], (v) => {
			if (v.property == this.props.data.property) {
				ret.push({
					label: v.name,
					value: v.id,
				})
			}
		})
		return ret
	}

	onDrop = (files, data, f, k) => {
		//console.log(files, data)
		//console.log(this.props)
		//return
		this.props.loadingStatus(true)
		this.files[data.folder] = files[0]
		const req = request.post(`${settings.ep}/inputDocument`)
		req.attach(this.files[data.folder].name, this.files[data.folder])
		req.set("Authorization", `Bearer ${localStorage.user}`)
		req.field(
			"attributes",
			JSON.stringify({ lot_id: this.props.data.id, sale_id: this.props.data.sale_id, data: data })
		)
		req.end((err, response) => {
			//return
			let resp = response.body

			if (err) {
				console.log(err)
				toast.error(resp.message)
			}
			if (resp.status == 200) {
				let state = clone(this.state)
				let i = _.findIndex(state.files, { id: data.id })
				state.files[i].status = true
				f.setFieldValue(`sales[${k}].documents`, JSON.parse(resp.array))
				state.data.sales[k].documents = JSON.parse(resp.array)
				this.setState(state, () => {
					console.log(this.state)
				})
			}
			this.props.loadingStatus(false)
		})
	}

	getMaterialField = (name, typeId, f) => {
		let val = f.values.lot[name]
		let material = _.find(this.props.payload.public.arc_materials, { type: typeId })
		let colors = helpers.arcColorTypes()
		let opts
		if (parseInt(val) > 0) {
			if (colors.includes(name)) {
				opts = helpers.selectARCColors(this.props.payload.public.arc_colors)
			} else if (material) {
				opts = this.props.payload.public.arc_materials
					.filter((v) => v.type === typeId)
					.map((v) => ({
						label: v.name,
						value: v.id,
					}))
					.sort((a, b) => a.label.localeCompare(b.label))
			}
			if (opts) {
				try {
					//? This try block looks at the acceptable materials for each classification/style.  So for exapmle COLTON Prairie allows certain types of brick, siding etc.  This allows them to limit that.  If there isn't any materials assigned to that style, then this is just skipped.
					if (f.values.floorplan) {
						let fp = _.find(this.props.payload.public.floorplans, { id: f.values.floorplan })
						if (fp?.classifications && fp.classifications?.length) {
							let classifications = []
							_.forEach(fp.classifications, (v) => {
								let c = _.find(this.props.payload.public.floorplan_classifications, { id: v })
								if (c) {
									classifications.push(c)
								}
							})
							// We have this plans classifcations now, now compile a list of allowed materials
							let allowed = []
							_.forEach(classifications, (v) => {
								if (v[name]) {
									allowed.push(...v[name])
								}
							})
							if (allowed.length) {
								opts = opts.filter((v) => {
									return allowed.includes(v.value)
								})
							}
						}
					}
				} catch (e) {
					console.log(e)
				}
				return (
					<ReactSelect
						name={`lot.${name}`}
						options={opts}
						value={parseInt(f.values.lot[name])}
						onBlur={f.setFieldTouched}
						onChange={f.setFieldValue}
					/>
				)
			}
		}
		return <Field name={`lot.${name}`} type="text" className="form__input" />
	}

	clearFile = (d, k) => {
		submitData("clearDocument", d).then((data) => {
			toast.success("Document has been cleared.")
			let state = _.cloneDeep(this.state)
			state.data.sales[k].documents = JSON.parse(data.documents)
			this.setState(state, () => {
				console.log(this.state)
			})
		})
		//this.setState({ hide: true })
	}

	compileDocs = (f, k) => {
		return _.map(this.state.files, (details) => {
			// Example of details :
			// {id: 1, name: "Resident Manual", dbName: "residentmanual", folder: "resident_manual", status: false}
			//console.log(details)
			let current = ""
			let doc = _.find(this.state.data.sales[k].documents, {
				type: details.dbName,
			})
			let docIndex = _.findIndex(this.state.data.sales[k].documents, {
				type: details.dbName,
			})
			if (this.state.data.sales[k].documents && doc && doc.status !== "awaiting" && doc.attachment) {
				current = (
					<p className={classNames("documentModal__currentAndClear", { hide: this.state.hide })}>
						<a
							href={`${settings.s3}${doc.attachment}`}
							target="_blank"
							key={doc.attachment}
							download={true}>
							Current Document
						</a>
						<a
							className="documentModal__clear"
							onClick={() =>
								this.clearFile({ attachment: doc.attachment, sale_id: this.state.data.sales[k].id }, k)
							}>
							<i className="fas fa-times-circle"></i>Clear File
						</a>
					</p>
				)
			} else {
				current = ""
			}
			return (
				<Fragment key={`${details.id}-${details.folder}`}>
					<li className={fieldStatus(details.folder, f)} key={`${k}-${details.folder}`}>
						<label htmlFor={`${details.folder}`}>
							{details.name}
							<br />
							{current}
						</label>
						{f.errors[details.folder] && f.touched[details.folder] && (
							<div className="form__message">{f.errors[details.folder]}</div>
						)}
						<Dropzone
							multiple={false}
							onDrop={(files) => {
								this.onDrop(files, details, f, k)
							}}>
							{({ getRootProps, getInputProps }) => (
								<section
									className={classNames("dropzone", {
										active: details.status,
									})}>
									<div {...getRootProps()} className="dropbox__cont">
										<input {...getInputProps()} />
										<p className="dropzone__action">
											Drag 'n' drop file or click here to update document.
										</p>
									</div>
								</section>
							)}
						</Dropzone>
						<div
							className={classNames("dropzone__status", {
								active: details.status,
							})}>
							<div
								className={classNames("dropzone__accepted", {
									active: details.status,
								})}>
								<i className="far fa-shield-check dropzone__icon"></i>
								<p className="dropzone__text">Accepted</p>
							</div>
						</div>
					</li>
					<li className="form__listItem" key={`date-${k}`}>
						<label>{details.name} Date</label>
						<DateField
							name={`sales[${k}].documents[${docIndex}].approved_date`}
							className="form__input"
							id={`${details.id}-${details.folder}`}
							value={
								f.values.sales &&
								f.values.sales[k] &&
								f.values.sales[k].documents &&
								f.values.sales[k].documents[docIndex] &&
								f.values.sales[k].documents[docIndex].approved_date
							}
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
						/>
					</li>
				</Fragment>
			)
		})
	}

	addl = (f, k) => {
		let g = _.get(settings, `addlBuyerFields.communitySpecific.${this.props?.data?.property}`)
		if (g) {
			return _.map(g, (v) => {
				if (v.type == "dropdown") {
					return (
						<li className={fieldStatus(v.id, f)} key={v.id}>
							<label htmlFor={v.id}>{v.name}</label>
							<ReactSelect
								name={`buyers[${k}].addl.${v.id}`}
								options={v.options}
								value={f.values.buyers && f.values.buyers[k] && f.values.buyers[k]?.addl?.[v.id]}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
							/>
						</li>
					)
				}
			})
		}
		return ""
	}

	profileDate = (f, k) => {
		let docIndex = _.findIndex(this.state.data.sales[k].documents, {
			type: "profile",
		})
		if (typeof docIndex !== "number") {
			console.log("No Buyer Profile Record found.")
			return ""
		}
		return (
			<li className="form__listItem" key={`date-${k}`}>
				<label>Buyer Profile Approved</label>
				<DateField
					name={`sales[${k}].documents[${docIndex}].approved_date`}
					className="form__input"
					id={`buyer_profile_approved`}
					value={
						f.values.sales &&
						f.values.sales[k] &&
						f.values.sales[k].documents &&
						f.values.sales[k].documents[docIndex] &&
						f.values.sales[k].documents[docIndex].approved_date
					}
					onChange={f.setFieldValue}
					onBlur={f.setFieldTouched}
				/>
			</li>
		)
	}

	brokerageCallback = (v, index) => {
		console.log(v, index)
		let state = _.cloneDeep(this.state)
		if (v[0] && v[0].addl) {
			_.setWith(state, `teams[${index}]`, v[0].addl.teams || [], Object)
			_.setWith(state, `offices[${index}]`, v[0].addl.offices || [], Object)
		} else {
			_.setWith(state, `teams[${index}]`, [], Object)
			_.setWith(state, `offices[${index}]`, [], Object)
		}
		this.setState(state, () => {
			console.log(this.state)
		})
	}

	wipeBrokerageOptions = (k) => {
		//Remove the teams + offices for this sale
		let state = _.cloneDeep(this.state)
		delete state.teams[k]
		delete state.offices[k]
		this.setState(state, () => {
			console.log(this.state)
		})
	}

	realtorFields = (f, k) => {
		if (f.values.sales[k].realtor_involved === 1) {
			return (
				<React.Fragment>
					<li className={fieldStatus("realtor", f)}>
						<label htmlFor="realtor">
							Realtor License # <sup>*</sup>
						</label>
						<Typeahead
							name={`sales[${k}].realtor`}
							className="form__input"
							value={f.values.sales[k].realtor}
							placeholder={f.values.sales[k].realtor}
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
							//touched={f.touched.sales[k].realtor}
							//error={f.errors.sales[k].realtor}
							reversed={true}
							ep="/typeaheadTrec"
							freetype={true}
						/>
					</li>
					<li className={fieldStatus("realtor_office", f)}>
						<label htmlFor="realtor_office">Realtor Office License #</label>
						{f.errors.sales &&
							f.touched.sales &&
							f.errors.sales[k] &&
							f.errors.sales[k].realtor_office &&
							f.touched.sales[k] &&
							f.touched.sales[k].realtor_office && (
								<div className="form__message">{f.errors.sales[k].realtor_office}</div>
							)}
						<Typeahead
							name={`sales[${k}].realtor_office`}
							className="form__input"
							value={f.values.sales[k].realtor_office}
							placeholder={f.values.sales[k].realtor_office}
							clearBrokerages={true}
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
							//touched={f.touched.sales[k].realtor}
							//error={f.errors.sales[k].realtor}
							reversed={true}
							ep="/typeaheadTrec"
							callback={this.brokerageCallback}
							index={k}
							freetype={true}
							onKeyUpMethod={this.wipeBrokerageOptions}
						/>
					</li>
					<li className={fieldStatus("realtor_office_office", f)}>
						<label htmlFor="realtor_office_office">Brokerage Office</label>
						<ReactSelect
							key={`sales[${k}].realtor_office_office`}
							name={`sales[${k}].realtor_office_office`}
							options={_.map(this.state.offices[k], (v, k) => {
								return { value: k, label: v }
							})}
							value={f.values.sales[k].realtor_office_office}
							onBlur={f.setFieldTouched}
							onChange={f.setFieldValue}
							allowNull={true}
						/>
					</li>
					<li className={fieldStatus("realtor_office_team", f)}>
						<label htmlFor="realtor_office_team">Brokerage Team</label>
						<ReactSelect
							key={`sales[${k}].realtor_office_team`}
							name={`sales[${k}].realtor_office_team`}
							options={_.map(this.state.teams[k], (v, k) => {
								return { value: k, label: v }
							})}
							value={f.values.sales[k].realtor_office_team}
							onBlur={f.setFieldTouched}
							onChange={f.setFieldValue}
							allowNull={true}
						/>
					</li>
				</React.Fragment>
			)
		}
	}

	renderSales = (f) => {
		//console.log(f)
		let states = _.clone(this.props.payload.public.states)
		states.unshift({ value: "", label: "" })
		return _.map(this.state.data.sales, (r, k) => {
			let buyer = _.find(this.state.data.buyers, { id: r.buyer_id })
			if (f.values?.buyers?.[k]?.buyer_country == "CA") states = helpers.canadianProvinces()
			let sp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
			if (!buyer) {
				return null
			}
			let salesperson = sp ? `${sp.first} ${sp.last}` : "Not available"
			let closing_date = ""
			if (r.closing_date) {
				closing_date = (
					<li className={fieldStatus("closing_date", f)}>
						<label htmlFor="closing_date">Closing Date</label>
						<DateField
							name={`sales[${k}].closing_date`}
							className="form__input"
							value={f.values.sales && f.values.sales[k] && f.values.sales[k].closing_date}
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
						/>
					</li>
				)
			}
			let bustout_date = ""
			if (r.bustout_date) {
				bustout_date = (
					<>
						<li className={fieldStatus("bustout_date", f)}>
							<label htmlFor="bustout_date">Cancel Date</label>
							<DateField
								name={`sales[${k}].bustout_date`}
								className="form__input"
								value={f.values.sales && f.values.sales[k] && f.values.sales[k].bustout_date}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
							/>
						</li>
						<li className={fieldStatus("bustout_reason", f)}>
							<label htmlFor="bustout_reason">Cancel Reason</label>
							<Field name={`sales[${k}].bustout_reason`} type="text" className="form__input" />
						</li>
					</>
				)
			}
			let cancel_date = ""
			if (r.cancel_date) {
				cancel_date = (
					<li className={fieldStatus("cancel_date", f)}>
						<label htmlFor="cancel_date">Cancel Date</label>
						<DateField
							name={`sales[${k}].cancel_date`}
							className="form__input"
							value={f.values.sales && f.values.sales[k] && f.values.sales[k].cancel_date}
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
						/>
					</li>
				)
			}
			//console.log(f)
			return (
				<AccordionItem key={k}>
					<AccordionItemHeading>
						<AccordionItemButton
							className={classNames("accordion__button", {
								"accordion__button--closed": r.closing_date,
								"accordion__button--busted": r.bustout_date,
								"accordion__button--transferred": r.transfer_date,
								"accordion__button--cancelled": r.cancel_date,
							})}>
							<h3>
								Sale: {buyer.primary_first} {buyer.primary_last} | Salesperson: {salesperson} | Buyer
								ID: #{buyer.id} | Sale ID: #{r.id}
							</h3>
						</AccordionItemButton>
					</AccordionItemHeading>
					<AccordionItemPanel>
						<>
							{!r.bustout_date && !r.closing_date && !r.transfer_date && (
								<div style={{ margin: "15px 0", textAlign: "right" }}>
									<a className="btn text-xs" onClick={() => this.setState({ moveModal: true })}>
										Move Sale
									</a>
								</div>
							)}
							{r.bustout_date &&
								k === this.state.data.sales.length - 1 &&
								!f?.values?.lot?.closing_date && (
									<div style={{ margin: "15px 0", textAlign: "right" }}>
										<a
											className="btn text-xs"
											onClick={() =>
												this.setState({ removeCancel: true, removeCancelDetails: r })
											}>
											Remove Cancel
										</a>
									</div>
								)}
							<div style={{ margin: "15px 0", textAlign: "right" }}>
								<a
									className="btn text-xs"
									onClick={() => this.setState({ deleteSale: true, deleteSaleDetails: r })}>
									Delete Sale
								</a>
							</div>
							{r.closing_date && (
								<div style={{ margin: "15px 0", textAlign: "right" }}>
									<a
										className="btn text-xs"
										onClick={() => this.setState({ removeClosing: true, removeClosingData: r })}>
										Remove Closing
									</a>
								</div>
							)}
							<ul className="lot__list" key="lotList">
								<li className={fieldStatus("salesperson", f)}>
									<label htmlFor="salesperson">Salesperson</label>
									<ReactSelect
										name={`sales[${k}].salesperson`}
										options={this.salespeopleList()}
										value={f.values.sales && f.values.sales[k] && f.values.sales[k].salesperson}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
										clearable
									/>
								</li>
								<li className={fieldStatus("price", f)}>
									<label htmlFor="price">Sale Price</label>
									<NumberField
										name={`sales[${k}].price`}
										type="text"
										className="form__input"
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.sales && f.touched.sales[k] && f.touched.sales[k].price}
										value={f.values.sales && f.values.sales[k] && f.values.sales[k].price}
										thousandSeparator={true}
										prefix="$"
									/>
								</li>
								{!_.get(settings, `disabled.closing_price`) && (
									<li className={fieldStatus("closing_price", f)}>
										<label htmlFor="closing_price">Closing Price</label>
										<NumberField
											name={`sales[${k}].closing_price`}
											type="text"
											className="form__input"
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={
												f.touched.sales &&
												f.touched.sales[k] &&
												f.touched.sales[k].closing_price
											}
											value={
												f.values.sales && f.values.sales[k] && f.values.sales[k].closing_price
											}
											thousandSeparator={true}
											prefix="$"
										/>
									</li>
								)}
								<li className={fieldStatus("sale_date", f)}>
									<label htmlFor="sale_date">Contract Date</label>
									<DateField
										name={`sales[${k}].sale_date`}
										className="form__input"
										value={f.values.sales && f.values.sales[k] && f.values.sales[k].sale_date}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
									/>
								</li>
								{settings?.enabled?.editSaleInputDate && (
									<li className={fieldStatus("addedDate", f)}>
										<label htmlFor="addedDate">Input Date</label>
										<DateField
											name={`sales[${k}].addedDate`}
											className="form__input"
											value={f.values.sales && f.values.sales[k] && f.values.sales[k].addedDate}
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
										/>
									</li>
								)}
								<li className={fieldStatus("estimated_closing", f)}>
									<label htmlFor="estimated_closing">Estimated Closing</label>
									<DateField
										name={`sales[${k}].estimated_closing`}
										className="form__input"
										value={
											f.values.sales && f.values.sales[k] && f.values.sales[k].estimated_closing
										}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
									/>
								</li>
								{closing_date}
								{bustout_date}
								{cancel_date}
								<li className={fieldStatus("primary_first", f)}>
									<label htmlFor="primary_first">Primary First</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].primary_first &&
										f.touched.buyers[k].primary_first && (
											<div className="form__message">{f.errors.buyers[k].primary_first}</div>
										)}
									<Field name={`buyers[${k}].primary_first`} type="text" className="form__input" />
								</li>
								<li className={fieldStatus("primary_last", f)}>
									<label htmlFor="primary_last">Primary Last</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].primary_last &&
										f.touched.buyers[k].primary_last && (
											<div className="form__message">{f.errors.buyers[k].primary_last}</div>
										)}
									<Field name={`buyers[${k}].primary_last`} type="text" className="form__input" />
								</li>
								<li className={fieldStatus("co_first", f)}>
									<label htmlFor="co_first">Co First</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].co_first &&
										f.touched.buyers[k].co_first && (
											<div className="form__message">{f.errors.buyers[k].co_first}</div>
										)}
									<Field name={`buyers[${k}].co_first`} type="text" className="form__input" />
								</li>
								<li className={fieldStatus("co_last", f)}>
									<label htmlFor="co_last">Co Last</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].co_last &&
										f.touched.buyers[k].co_last && (
											<div className="form__message">{f.errors.buyers[k].co_last}</div>
										)}
									<Field name={`buyers[${k}].co_last`} type="text" className="form__input" />
								</li>
								<li className={fieldStatus("primary_age", f)}>
									<label htmlFor="primary_age">Primary Age Range</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].primary_age &&
										f.touched.buyers[k].primary_age && (
											<div className="form__message">{f.errors.buyers[k].primary_age}</div>
										)}
									<ReactSelect
										name={`buyers[${k}].primary_age`}
										options={[
											{
												value: "18 - 24",
												label: "18 - 24",
											},
											{
												value: "25 - 34",
												label: "25 - 34",
											},
											{
												value: "35 - 44",
												label: "35 - 44",
											},
											{
												value: "45 - 54",
												label: "45 - 54",
											},
											{
												value: "55 - 64",
												label: "55 - 64",
											},
											{
												value: "65+",
												label: "65+",
											},
										]}
										value={f.values.buyers && f.values.buyers[k] && f.values.buyers[k].primary_age}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("primary_occupation", f)}>
									<label htmlFor="primary_occupation">Primary Occupation</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].primary_occupation &&
										f.touched.buyers[k].primary_occupation && (
											<div className="form__message">{f.errors.buyers[k].primary_occupation}</div>
										)}
									<ReactSelect
										name={`buyers[${k}].primary_occupation`}
										options={this.props.payload.public.occupations}
										value={
											f.values.buyers &&
											f.values.buyers[k] &&
											f.values.buyers[k].primary_occupation
										}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("primary_email", f)}>
									<label htmlFor="primary_email">Primary Email</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].primary_email &&
										f.touched.buyers[k].primary_email && (
											<div className="form__message">{f.errors.buyers[k].primary_email}</div>
										)}
									<Field name={`buyers[${k}].primary_email`} type="email" className="form__input" />
								</li>
								<li className={fieldStatus("primary_employer", f)}>
									<label htmlFor="primary_employer">Primary Employer</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].primary_employer &&
										f.touched.buyers[k].primary_employer && (
											<div className="form__message">{f.errors.buyers[k].primary_employer}</div>
										)}
									<Field name={`buyers[${k}].primary_employer`} type="text" className="form__input" />
								</li>
								<li className={fieldStatus("has_co", f)}>
									<label htmlFor="has_co">Has Co</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].has_co &&
										f.touched.buyers[k].has_co && (
											<div className="form__message">{f.errors.buyers[k].has_co}</div>
										)}
									<Field
										name={`buyers[${k}].has_co`}
										type="checkbox"
										className="form__input"
										onChange={(event) => {
											console.log(event)
											f.setFieldValue(`buyers[${k}].has_co`, event.target.checked)
										}}
									/>
								</li>
								<li className={fieldStatus("co_age", f)}>
									<label htmlFor="co_age">Co Age Range</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].co_age &&
										f.touched.buyers[k].co_age && (
											<div className="form__message">{f.errors.buyers[k].co_age}</div>
										)}
									<ReactSelect
										name={`buyers[${k}].co_age`}
										options={[
											{ value: null, label: "" },
											{
												value: "18 - 24",
												label: "18 - 24",
											},
											{
												value: "25 - 34",
												label: "25 - 34",
											},
											{
												value: "35 - 44",
												label: "35 - 44",
											},
											{
												value: "45 - 54",
												label: "45 - 54",
											},
											{
												value: "55 - 64",
												label: "55 - 64",
											},
											{
												value: "65+",
												label: "65+",
											},
										]}
										value={f.values.buyers && f.values.buyers[k] && f.values.buyers[k].co_age}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("co_occupation", f)}>
									<label htmlFor="co_occupation">Co Occupation</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].co_occupation &&
										f.touched.buyers[k].co_occupation && (
											<div className="form__message">{f.errors.buyers[k].co_occupation}</div>
										)}
									<ReactSelect
										name={`buyers[${k}].co_occupation`}
										options={[
											...[{ label: "", value: "" }],
											...this.props.payload.public.occupations,
										]}
										value={
											f.values.buyers && f.values.buyers[k] && f.values.buyers[k].co_occupation
										}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("co_email", f)}>
									<label htmlFor="co_email">Co Email</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].co_email &&
										f.touched.buyers[k].co_email && (
											<div className="form__message">{f.errors.buyers[k].co_email}</div>
										)}
									<Field name={`buyers[${k}].co_email`} type="email" className="form__input" />
								</li>
								<li className={fieldStatus("co_employer", f)}>
									<label htmlFor="co_employer">Co Employer</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].co_employer &&
										f.touched.buyers[k].co_employer && (
											<div className="form__message">{f.errors.buyers[k].co_employer}</div>
										)}
									<Field name={`buyers[${k}].co_employer`} type="text" className="form__input" />
								</li>
								<li className={fieldStatus("buyer_address", f)}>
									<label htmlFor="buyer_address">Address</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].buyer_address &&
										f.touched.buyers[k].buyer_address && (
											<div className="form__message">{f.errors.buyers[k].buyer_address}</div>
										)}
									<Field name={`buyers[${k}].buyer_address`} type="text" className="form__input" />
								</li>
								<li className={fieldStatus("buyer_city", f)}>
									<label htmlFor="buyer_city">City</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].buyer_city &&
										f.touched.buyers[k].buyer_city && (
											<div className="form__message">{f.errors.buyers[k].buyer_city}</div>
										)}
									<Field name={`buyers[${k}].buyer_city`} type="text" className="form__input" />
								</li>
								<li className={fieldStatus("buyer_state", f)}>
									<label htmlFor="buyer_state">State</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].buyer_state &&
										f.touched.buyers[k].buyer_state && (
											<div className="form__message">{f.errors.buyers[k].buyer_state}</div>
										)}
									<ReactSelect
										name={`buyers[${k}].buyer_state`}
										options={states}
										value={f.values.buyers && f.values.buyers[k] && f.values.buyers[k].buyer_state}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("buyer_zip", f)}>
									<label htmlFor="buyer_zip">Zip</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].buyer_zip &&
										f.touched.buyers[k].buyer_zip && (
											<div className="form__message">{f.errors.buyers[k].buyer_zip}</div>
										)}
									<Field name={`buyers[${k}].buyer_zip`} type="text" className="form__input" />
								</li>
								<li className={fieldStatus("buyer_country", f)}>
									<label htmlFor="buyer_country">Country</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].buyer_country &&
										f.touched.buyers[k].buyer_country && (
											<div className="form__message">{f.errors.buyers[k].buyer_country}</div>
										)}
									<ReactSelect
										name={`buyers[${k}].buyer_country`}
										options={this.props.payload.public.countries}
										value={
											f.values.buyers && f.values.buyers[k] && f.values.buyers[k].buyer_country
										}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								{settings.enabled && settings.enabled.buyer_phone && (
									<li className={fieldStatus("buyer_phone", f)}>
										<label htmlFor="buyer_phone">Buyer Phone</label>
										{f.errors.buyers &&
											f.touched.buyers &&
											f.errors.buyers[k].buyer_phone &&
											f.touched.buyers[k].buyer_phone && (
												<div className="form__message">{f.errors.buyers[k].buyer_phone}</div>
											)}
										<NumberField
											name={`buyers[${k}].buyer_phone`}
											value={
												f.values.buyers && f.values.buyers[k] && f.values.buyers[k].buyer_phone
											}
											format="+1 (###) ###-####"
											className="form__input"
											isNumericString
											onChange={(name, v) => {
												f.setFieldValue(`buyers[${k}].buyer_phone`, v)
											}}
											onBlur={() => f.setFieldTouched("buyer_phone", true)}
										/>
									</li>
								)}
								<li className={fieldStatus("is_relo", f)}>
									<label htmlFor="is_relo">Relo</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].is_relo &&
										f.touched.buyers[k].is_relo && (
											<div className="form__message">{f.errors.buyers[k].is_relo}</div>
										)}
									<ReactSelect
										name={`buyers[${k}].is_relo`}
										options={[
											{ value: 0, label: "No" },
											{ value: 1, label: "Yes" },
										]}
										value={f.values.buyers && f.values.buyers[k] && f.values.buyers[k].is_relo}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("realtor_involved", f)}>
									<label htmlFor="realtor_involved">Realtor Involved?</label>
									<ReactSelect
										name={`sales[${k}].realtor_involved`}
										options={[
											{
												value: 0,
												label: "No",
											},
											{
												value: 1,
												label: "Yes",
											},
										]}
										className="form__input"
										value={f.values.sales[k].realtor_involved}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
									/>
								</li>
								{this.realtorFields(f, k)}
								<li className={fieldStatus("first_time", f)}>
									<label htmlFor="first_time">First Time</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].first_time &&
										f.touched.buyers[k].first_time && (
											<div className="form__message">{f.errors.buyers[k].first_time}</div>
										)}
									<ReactSelect
										name={`buyers[${k}].first_time`}
										options={[
											{ value: 0, label: "No" },
											{ value: 1, label: "Yes" },
										]}
										value={f.values.buyers && f.values.buyers[k] && f.values.buyers[k].first_time}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("is_moving_within", f)}>
									<label htmlFor="is_moving_within">Is Moving Within?</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].is_moving_within &&
										f.touched.buyers[k].is_moving_within && (
											<div className="form__message">{f.errors.buyers[k].is_moving_within}</div>
										)}
									<ReactSelect
										name={`buyers[${k}].is_moving_within`}
										options={[
											{ value: 0, label: "No" },
											{ value: 1, label: "Yes" },
										]}
										value={
											f.values.buyers && f.values.buyers[k] && f.values.buyers[k].is_moving_within
										}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("has_extended_fam", f)}>
									<label htmlFor="has_extended_fam">Extended Family in House?</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].has_extended_fam &&
										f.touched.buyers[k].has_extended_fam && (
											<div className="form__message">{f.errors.buyers[k].has_extended_fam}</div>
										)}
									<ReactSelect
										name={`buyers[${k}].has_extended_fam`}
										options={[
											{ value: 0, label: "No" },
											{ value: 1, label: "Yes" },
										]}
										value={
											f.values.buyers && f.values.buyers[k] && f.values.buyers[k].has_extended_fam
										}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("num_residents", f)}>
									<label htmlFor="num_residents">Total Number of Residents</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].num_residents &&
										f.touched.buyers[k].num_residents && (
											<div className="form__message">{f.errors.buyers[k].num_residents}</div>
										)}
									<ReactSelect
										name={`buyers[${k}].num_residents`}
										options={this.numChildren()}
										value={
											f.values.buyers && f.values.buyers[k] && f.values.buyers[k].num_residents
										}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("traffic_source", f)}>
									<label htmlFor="traffic_source">Traffic Source</label>
									<ReactSelect
										name={`sales[${k}].traffic_source`}
										options={this.trafficSources()}
										value={f.values.sales && f.values.sales[k] && f.values.sales[k].traffic_source}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("purchase_reason", f)}>
									<label htmlFor="purchase_reason">Important Reason</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].purchase_reason &&
										f.touched.buyers[k].purchase_reason && (
											<div className="form__message">{f.errors.buyers[k].purchase_reason}</div>
										)}
									<Field name={`buyers[${k}].purchase_reason`} type="text" className="form__input" />
								</li>
								<li
									className={fieldStatus("other_communities_considered", f)}
									key={`other_communities_considered`}>
									<label htmlFor="other_communities_considered">Other Communities Considered</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].other_communities_considered &&
										f.touched.buyers[k].other_communities_considered && (
											<div className="form__message">
												{f.errors.buyers[k].other_communities_considered}
											</div>
										)}
									<Field
										name={`buyers[${k}].other_communities_considered`}
										type="text"
										className="form__input"
									/>
								</li>
								<li className={fieldStatus("visited_infocenter", f)}>
									<label htmlFor="visited_infocenter">Info Center Visited</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].visited_infocenter &&
										f.touched.buyers[k].visited_infocenter && (
											<div className="form__message">{f.errors.buyers[k].visited_infocenter}</div>
										)}
									<ReactSelect
										name={`buyers[${k}].visited_infocenter`}
										options={[
											{ value: 0, label: "No" },
											{ value: 1, label: "Yes" },
										]}
										value={
											f.values.buyers &&
											f.values.buyers[k] &&
											f.values.buyers[k].visited_infocenter
										}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("community_counselor", f)}>
									<label htmlFor="community_counselor">Community Counselor</label>
									{f.errors.buyers &&
										f.touched.buyers &&
										f.errors.buyers[k].community_counselor &&
										f.touched.buyers[k].community_counselor && (
											<div className="form__message">
												{f.errors.buyers[k].community_counselor}
											</div>
										)}
									<Field
										name={`buyers[${k}].community_counselor`}
										type="text"
										className="form__input"
									/>
								</li>
								<li className={fieldStatus("has_disclosurenotice", f)}>
									<label htmlFor="has_disclosurenotice">Disclosure Notice</label>
									<ReactSelect
										name={`buyers[${k}].has_disclosurenotice`}
										options={[
											{ value: 0, label: "No" },
											{ value: 1, label: "Yes" },
										]}
										value={
											f.values.buyers &&
											f.values.buyers[k] &&
											f.values.buyers[k].has_disclosurenotice
										}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("has_drillsitenotice", f)}>
									<label htmlFor="has_drillsitenotice">Drillsite Notice</label>
									<ReactSelect
										name={`buyers[${k}].has_drillsitenotice`}
										options={[
											{ value: 0, label: "No" },
											{ value: 1, label: "Yes" },
										]}
										value={
											f.values.buyers &&
											f.values.buyers[k] &&
											f.values.buyers[k].has_drillsitenotice
										}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("comments", f)}>
									<label htmlFor="comments">Comments</label>
									{f.errors.sales &&
										f.touched.sales &&
										f.errors.sales[k].comments &&
										f.touched.sales[k].comments && (
											<div className="form__message">{f.errors.sales[k].comments}</div>
										)}
									<TextArea
										name={`sales[${k}].comments`}
										className="form__textarea"
										value={f.values.sales && f.values.sales[k] && f.values.sales[k].comments}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
									/>
								</li>
								{this.profileDate(f, k)}
								{this.compileDocs(f, k)}
								{this.addl(f, k)}
							</ul>
						</>
					</AccordionItemPanel>
				</AccordionItem>
			)
		})
	}

	additionalFields = (area, type, f) => {
		if (!settings.specialFields || !_.has(settings, `specialFields.${area}.${type}`)) {
			return
		}
		return _.map(settings.specialFields.lot[type][this.props.data.property], (v, k) => {
			let req = v.required ? <sup>*</sup> : ""
			let field = ""
			if (v.type == "number") {
				field = (
					<NumberField
						name={`${area}.${v.name}`}
						type="text"
						className="form__input"
						onChange={f.setFieldValue}
						onBlur={f.setFieldTouched}
						touched={f.touched[v.name]}
						value={f.values.lot[v.name]}
						thousandSeparator={true}
						prefix={v.prefix}
						float={v.float}
					/>
				)
			} else {
				field = <Field name={`${type}[${v.name}]`} type="text" className="form__input" />
			}
			return (
				<li className={fieldStatus(v.name, f)} key={v.name}>
					<label htmlFor={v.name}>
						{v.english}
						{req}
					</label>
					{f.errors[v.name] && f.touched[v.name] && <div className="form__message">{f.errors[v.name]}</div>}
					{field}
				</li>
			)
		})
	}

	removeImage = (k, f) => {
		let images = _.clone(this.state.images)
		images.splice(k, 1)
		this.setState({ images })
		f.setFieldValue("lot.images", images)
		let values = {
			files: images,
			type: "lot",
			id: this.state.data.lot.id,
		}
		submitData("removeImage", values).then((data) => {
			toast.success(data.message)
		})
	}

	feesTable = (f) => {
		let d = settings?.localFields?.feesTable
		if (!d) return
		d.property = this.props.data.property
		return (
			<AccordionItem uuid={"feesTable"}>
				<AccordionItemHeading>
					<AccordionItemButton>
						<h3>Fees Table</h3>
					</AccordionItemButton>
				</AccordionItemHeading>
				<AccordionItemPanel>
					<TableRowField
						presets={d}
						fields={d.fields}
						data={f.values.lot?.addl?.feesTable}
						allowNull={true}
						onChange={(v) => {
							// This may be  dev specific?
							_.forEach(v, (row) => {
								if (row.date && !row.status) row.status = 1
							})
							f.setFieldValue("lot.addl.feesTable", v)
						}}
					/>
				</AccordionItemPanel>
			</AccordionItem>
		)
	}

	renderAdditionalFields = (f, set) => {
		// these fields are all in values.addl
		let property = this.props.data.property
		if (!_.get(settings, `localFields.${set}`)) return
		let ret = []
		if (!f.values.lot.addl) {
			f.values.lot.addl = {}
		}
		let lot = f.values.lot
		_.forEach(settings.localFields[set], (v, k) => {
			if (Array.isArray(v.properties) && !v.properties.includes(property)) return
			let r
			if (v.type == "NumberField") {
				r = (
					<li className="form__listItem">
						<label htmlFor={k}>{k}</label>
						<NumberField
							name={"lot.addl." + k}
							type="text"
							className="form__input"
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
							//touched={f.touched.addl[k]}

							value={f.values.lot.addl[k]}
							thousandSeparator={v.options.thousandSeparator}
							prefix={v.options.prefix}
							float={v.options.float}
						/>
					</li>
				)
			} else if (v.type == "DateField") {
				r = (
					<li className="form__listItem">
						<label htmlFor={k}>{k}</label>
						<DateField
							name={"lot.addl." + k}
							className="form__input"
							value={f.values.lot.addl[k]}
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
						/>
					</li>
				)
			} else if (v.type == "Dropdown") {
				// Can be strings, which we just use here
				if (v.options && typeof v.options[0] === "string") {
					r = (
						<li className="form__listItem">
							<label htmlFor={k}>{k}</label>
							<ReactSelect
								name={"lot.addl." + k}
								options={_.map(v.options, (row) => {
									return { value: row, label: row }
								})}
								value={f.values.lot.addl[k]}
								onBlur={f.setFieldTouched}
								clearable
								onChange={f.setFieldValue}
							/>
						</li>
					)
				}
				// Or label/value
				else if (v.options && typeof v.options[0] === "object") {
					r = (
						<li className="form__listItem">
							<label htmlFor={k}>{k}</label>
							<ReactSelect
								name={"lot.addl." + k}
								options={v.options}
								value={f.values.lot.addl[k]}
								onBlur={f.setFieldTouched}
								clearable
								onChange={f.setFieldValue}
							/>
						</li>
					)
				}
			} else if (v.type == "Checkbox") {
				r = (
					<li className="form__listItem">
						<label htmlFor={k}>{k}</label>
						<Field name={"lot.addl." + k} type="checkbox" className="form__input" />
					</li>
				)
			} else if (v.type == "Sum") {
				let val
				let items = []
				try {
					items = _.map(v.fields, (field) => {
						if (lot.hasOwnProperty(field)) {
							// this is a core r from pipsy
							if (lot[field]) {
								return lot[field]
							}
							return 0
						} else if (lot.addl && lot.addl.hasOwnProperty(field)) {
							if (lot.addl[field]) {
								return lot.addl[field]
							}
							return 0
						} else return 0
					})
				} catch (e) {
					console.log(e)
				}
				items = helpers.cleanArray(items)
				val = _.sum(items)
				r = (
					<li className="form__listItem">
						<label>{k}</label>
						{numeral(val).format("$0,0.00")}
					</li>
				)
			}
			//? Caldwell - maybe someday move this to the settings file?
			else if (v.type == "TotalMarketingFee") {
				let val = totalMarketingFee(f.values.lot, this.props.payload.exec.sales)
				r = (
					<li className="form__listItem">
						<label>{k}</label>
						{numeral(val).format("$0,0.00")}
					</li>
				)
			} else if (v.type == "MarketingFeeDue") {
				try {
					let val = 0
					let paid = parseFloat(_.get(f.values, `lot.addl[Marketing Fee Paid]`))
					let initial = parseFloat(_.get(f.values, `lot.addl[Initial Marketing Fee]`))
					let total = totalMarketingFee(f.values.lot, this.props.payload.exec.sales)
					if (!paid) paid = 0
					val = total - (paid + initial)
					r = (
						<li className="form__listItem">
							<label>{k}</label>
							{numeral(val).format("$0,0.00")}
						</li>
					)
				} catch (e) {
					console.log(e)
				}
			} else if (v.type == "InterestAccrued") {
				let val = calculateInterest(f.values)
				if (val) val = numeral(val).format("$0,0.00")
				r = (
					<li className="form__listItem">
						<label>{k}</label>
						{val ? val : "N/A"}
					</li>
				)
			} else if (v.type == "TotalTrueUp") {
				let close = _.find(f.values.sales, (r) => r.closing_date)
				let val = calculateTrueUp(f.values.lot, close)
				r = (
					<li className="form__listItem">
						<label>{k}</label>
						{numeral(val).format("$0,0.00")}
					</li>
				)
			} else if (v.type == "TrueUpBalance") {
				let close = _.find(f.values.sales, (r) => r.closing_date)
				let trueUp = calculateTrueUp(f.values.lot, close)
				let paid = _.get(f.values, `lot.addl[True Up Fee Paid]`)
				let val = trueUp
				// Check for caps
				let cap = _.get(f.values, `lot.addl[True Up Cap]`)
				let min = _.get(f.values, `lot.addl[True Up Minimum]`)
				if (cap && val > cap) trueUp = cap

				if (paid && trueUp) {
					val = trueUp - paid
				}
				if (!min && val < 0) val = 0
				if (min && val < min) val = min
				let value = ""
				if (val) value = numeral(val).format("$0,0.00")
				else if (val === 0) value = "$0.00"
				r = (
					<li className="form__listItem">
						<label>{k}</label>
						{value}
					</li>
				)
			} else {
				r = (
					<li className="form__listItem">
						<label htmlFor={k}>{k}</label>
						<Field name={"lot.addl." + k} type="text" className="form__input" />
					</li>
				)
			}
			ret.push(r)
		})
		if (_.get(settings, `enabled.hudDocs`) && settings.enabled.hudDocs.includes(f.values?.lot?.property)) {
			let existingFile
			if (f.values.lot.hud_doc) {
				existingFile = (
					<a className="text-xs" href={`${settings.s3}${f.values.lot.hud_doc}`} target="_blank">
						View File
					</a>
				)
			}
			ret.push(
				<>
					<li className={fieldStatus("hud_doc", f)}>
						<label htmlFor="hud_doc">HUD Doc {existingFile}</label>
						<input
							name="lot.filesToUpload.hud_doc"
							type="file"
							id="lot.filesToUpload.hud_doc"
							className="noBorder"
							onChange={(event) => {
								f.setFieldValue("lot.filesToUpload.hud_doc", event.currentTarget.files[0])
							}}
						/>
					</li>
				</>
			)
		}

		return ret
	}

	compileThumbs = (f) => {
		const arrayMove = require("array-move")
		const onChange = (sourceId, sourceIndex, targetIndex) => {
			//console.log(sourceId, sourceIndex, targetIndex)
			let images = _.clone(this.state.images)
			images = arrayMove(images, sourceIndex, targetIndex)
			images = _.compact(images)
			this.setState({ images })
			f.values.lot.images = images
		}
		let rows = Math.ceil(this.state.images.length / 4)
		let height = rows * 220
		return (
			<GridContextProvider onChange={onChange}>
				<GridDropZone
					id="items"
					boxesPerRow={4}
					rowHeight={200}
					style={{ height: `${height}px`, width: "100%" }}>
					{this.state.images.map((item, k) => {
						let url
						if (item?.url && item.url.includes("http")) {
							url = item.url
						} else {
							url = `${settings.s3}${item?.url}`
						}
						// Parantheses in filename break image thumbnail
						url = decodeURI(url) // decding first because some url's are encoded already....% then gets to %25.
						url = encodeURI(url)
						url = url.replace(/\(/g, "%28").replace(/\)/g, "%29")
						let icon = (
							<div
								className="imageZone__thumb"
								key={`thumb` + item?.url}
								style={{
									backgroundImage: `url(${url})`,
								}}>
								<i
									className="fas fa-times-circle formFiles__removeIcon"
									onClick={() => this.removeImage(k, f)}></i>
							</div>
						)
						return (
							<GridItem key={item?.url} className="imageZone__block">
								<div
									className="imageGridItem"
									onClick={() => {
										let sel = _.clone(this.state.selectedImages)
										if (sel.includes(k)) sel = _.filter(sel, (v) => v !== k)
										else sel.push(k)
										this.setState({ selectedImages: sel })
									}}
									style={{
										width: "100%",
										height: "100%",
										paddingBottom: "20px",
										paddingRight: "20px",
										opacity: this.state.selectedImages.includes(k) ? 0.6 : 1,
									}}>
									{icon}
								</div>
							</GridItem>
						)
					})}
				</GridDropZone>
			</GridContextProvider>
		)
	}

	removeARCApprovalButton = (f) => {
		try {
			if (settings?.arc && f?.values?.lot?.arc_approved) {
				return (
					<div
						className="btn !bg-red-700 !border-red-700 text-xs"
						onClick={async () => {
							await submitDataAsync("mainIngest", {
								action: "removeARCApproval",
								id: f.values.lot.id,
							})
							this.props.loadingStatus(true)
							await this.pullLot()
							this.props.getPayload()
							toast.success("ARC Approval Removed")
						}}>
						Remove ARC Approval
					</div>
				)
			}
		} catch (e) {
			console.log(e)
		}
		return null
	}

	resendApprovalLetter = (f) => {
		try {
			if (settings?.arc && f?.values?.lot?.arc_approved) {
				return (
					<div
						className="btn !bg-green-700 !border-green-700 text-xs mr-2"
						onClick={async () => {
							this.props.loadingStatus(true)
							await submitDataAsync("mainIngest", {
								action: "resendARCApproval",
								id: f.values.lot.id,
							})
							await this.pullLot()
							this.props.getPayload()
							this.props.loadingStatus(false)
							toast.success("ARC Approval Resent")
						}}>
						Resend ARC Approval Email
					</div>
				)
			}
		} catch (e) {
			console.log(e)
		}
		return null
	}

	downloadApproval = (f) => {
		try {
			if (this.state.data?.lot?.arc_approved && this.state.data?.lot?.id) {
				return (
					<div
						className="btn !bg-green-700 !border-green-700 text-xs mr-2"
						onClick={async () => {
							this.generateResponseFile(this.state.data?.lot)
						}}>
						Download ARC Approval
					</div>
				)
			}
		} catch (e) {
			console.log(e)
		}
		return null
	}

	generateResponseFile = async (lot) => {
		this.props.loadingStatus(true)
		let resp = await submitDataAsync("mainIngest", {
			lot_id: lot.id,
			action: "buildLotResponseFile",
		})
		let url = settings.s3 + "/" + resp.message
		if (resp.status == 200) {
			toast.success("Response file generated")
			window.open(url, "_blank")
		} else {
			toast.error("Error generating response file")
		}
		this.props.loadingStatus(false)
	}

	renderForm = (f) => {
		let submitButton
		if (this.state.canSubmit) {
			submitButton = <input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
		}
		//console.log(f)
		let arcFile =
			settings.arc && _.has(f, `values.lot.arc_data.plan_file`) ? (
				<a href={`${settings.s3}${f.values.lot.arc_data.plan_file}`} className="small">
					{" "}
					View File
				</a>
			) : (
				""
			)
		let showARC = false
		if (settings.arc || settings.arcThirdParty) showARC = true
		return (
			<Form>
				<Accordion
					allowZeroExpanded={true}
					allowMultipleExpanded={true}
					preExpanded={["lotInfo", "construction", "homeInfo", "priceParticipation", "buyers"]}>
					<AccordionItem uuid={"lotInfo"}>
						<AccordionItemHeading>
							<AccordionItemButton>
								<h3>Lot Info</h3>
							</AccordionItemButton>
						</AccordionItemHeading>
						<AccordionItemPanel>
							<ul className="lot__list">
								<li className={fieldStatus("lot_id", f)}>
									<label htmlFor="lot_id">Lot ID</label>#{this.props.data.id}
								</li>
								<li className={fieldStatus("builder", f)}>
									<label htmlFor="builder">Builder</label>
									{f.errors.builder && f.touched.builder && (
										<div className="form__message">{f.errors.builder}</div>
									)}
									<ReactSelect
										name={`lot.builder`}
										options={this.createOptions("builders", true)}
										value={f.values.lot.builder}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
										clearable={true}
									/>
								</li>
								<li className={fieldStatus("address", f)}>
									<label htmlFor="address">Address</label>
									{f.errors.address && f.touched.address && (
										<div className="form__message">{f.errors.address}</div>
									)}
									<Field name="lot.address" type="text" className="form__input" />
								</li>
								<li className={fieldStatus("lot", f)}>
									<label htmlFor="lot">Lot</label>
									{f.errors.lot && f.touched.lot && (
										<div className="form__message">{f.errors.lot}</div>
									)}
									<Field name="lot.lot" type="text" className="form__input" />
								</li>
								<li className={fieldStatus("block", f)}>
									<label htmlFor="block">Block</label>
									{f.errors.block && f.touched.block && (
										<div className="form__message">{f.errors.block}</div>
									)}
									<Field name="lot.block" type="text" className="form__input" />
								</li>
								<li className={fieldStatus("section", f)}>
									<label htmlFor="section">{settings?.renames?.section || "Section"}</label>
									{f.errors.section && f.touched.section && (
										<div className="form__message">{f.errors.section}</div>
									)}
									<ReactSelect
										name={`lot.section_id`}
										options={this.propertyLimited("sections")}
										value={f.values.lot.section_id}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("developer", f)}>
									<label htmlFor="developer">Developer</label>
									{f.errors.developer && f.touched.developer && (
										<div className="form__message">{f.errors.developer}</div>
									)}
									<ReactSelect
										name={`lot.developer`}
										options={this.createOptions("developers", true)}
										value={f.values.lot.developer}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("subdivision", f)}>
									<label htmlFor="subdivision">Subdivision</label>
									{f.errors.subdivision && f.touched.subdivision && (
										<div className="form__message">{f.errors.subdivision}</div>
									)}
									<ReactSelect
										name={`lot.subdivision`}
										options={this.propertyLimited("subdivisions")}
										value={f.values.lot.subdivision}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("neighborhood", f)}>
									<label htmlFor="neighborhood">Neighborhood</label>
									{f.errors.neighborhood && f.touched.neighborhood && (
										<div className="form__message">{f.errors.neighborhood}</div>
									)}
									<ReactSelect
										name={`lot.neighborhood`}
										options={this.propertyLimited("neighborhoods")}
										value={f.values.lot.neighborhood}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("model", f)}>
									<label htmlFor="model">Model</label>
									{f.errors.model && f.touched.model && (
										<div className="form__message">{f.errors.model}</div>
									)}
									<ReactSelect
										name={`lot.model`}
										options={[
											{ value: 0, label: "No" },
											{ value: 1, label: "Yes" },
										]}
										value={f.values.lot.model}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("lot_type", f)}>
									<label htmlFor="lot_type">Lot Type</label>
									{f.errors.lot_type && f.touched.lot_type && (
										<div className="form__message">{f.errors.lot_type}</div>
									)}
									<ReactSelect
										name={`lot.lot_type`}
										options={this.propertyLimited("lot_types")}
										value={f.values.lot.lot_type}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("home_type", f)}>
									<label htmlFor="home_type">Home Type</label>
									{f.errors.home_type && f.touched.home_type && (
										<div className="form__message">{f.errors.home_type}</div>
									)}
									<ReactSelect
										name={`lot.home_type`}
										options={this.propertyLimited("home_types")}
										value={f.values.lot.home_type}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("site_id", f)}>
									<label htmlFor="site_id">Site</label>
									{f.errors.site_id && f.touched.site_id && (
										<div className="form__message">{f.errors.site_id}</div>
									)}
									<ReactSelect
										name={`lot.site_id`}
										options={this.createOptions("sites", true)}
										value={f.values.lot.site_id}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
										clearable={true}
										isMulti
									/>
								</li>
								<li className={fieldStatus("isd", f)}>
									<label htmlFor="isd">ISD</label>
									{f.errors.isd && f.touched.isd && (
										<div className="form__message">{f.errors.isd}</div>
									)}
									<ReactSelect
										name={`lot.isd`}
										options={this.createOptions("isds", true)}
										value={f.values.lot.isd}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("lid", f)}>
									<label htmlFor="lid">LID</label>
									{f.errors.lid && f.touched.lid && (
										<div className="form__message">{f.errors.lid}</div>
									)}
									<ReactSelect
										name={`lot.lid`}
										options={this.createOptions("lids", true)}
										value={f.values.lot.lid}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("mud", f)}>
									<label htmlFor="mud">MUD</label>
									{f.errors.mud && f.touched.mud && (
										<div className="form__message">{f.errors.mud}</div>
									)}
									<ReactSelect
										name={`lot.mud`}
										options={this.createOptions("muds", true)}
										value={f.values.lot.mud}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("acreage", f)}>
									<label htmlFor="acreage">Acreage</label>
									{f.errors.acreage && f.touched.acreage && (
										<div className="form__message">{f.errors.acreage}</div>
									)}
									<NumberField
										name="lot.acreage"
										type="text"
										className="form__input"
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.acreage}
										value={f.values.lot.acreage}
										thousandSeparator={true}
										decimals={4}
									/>
								</li>
								<li className={fieldStatus("admin_notes", f)}>
									<label htmlFor="admin_notes">Admin Notes</label>
									{f.errors.admin_notes && f.touched.admin_notes && (
										<div className="form__message">{f.errors.admin_notes}</div>
									)}
									<TextArea
										name="lot.admin_notes"
										className="form__textarea"
										value={f.values.lot.admin_notes}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
									/>
								</li>
								<li className={fieldStatus("is_featured", f)}>
									<label htmlFor="is_featured">High Visibility</label>
									{f.errors.is_featured && f.touched.is_featured && (
										<div className="form__message">{f.errors.is_featured}</div>
									)}
									<ReactSelect
										name={`lot.is_featured`}
										options={[
											{ value: 0, label: "No" },
											{ value: 1, label: "Yes" },
										]}
										value={f.values.lot.is_featured}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("gated", f)}>
									<label htmlFor="gated">Gated Section</label>
									{this.props.data.gated ? "Yes" : "No"}
								</li>
								<li className={fieldStatus("senior", f)}>
									<label htmlFor="senior">Active Adult</label>
									{this.props.data.senior ? "Yes" : "No"}
								</li>
								{!_.get(settings, `localFields.marketingFees`) && (
									<li className={fieldStatus("fee_marketing", f)}>
										<label htmlFor="fee_marketing">Marketing Fee</label>
										{f.errors.fee_marketing && f.touched.fee_marketing && (
											<div className="form__message">{f.errors.fee_marketing}</div>
										)}
										<NumberField
											name="lot.fee_marketing"
											type="text"
											className="form__input"
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.fee_marketing}
											value={f.values.lot.fee_marketing}
											thousandSeparator={true}
											prefix="$"
											float={true}
										/>
									</li>
								)}
								{_.get(settings, `enabled.lotReservations`) && (
									<>
										<li className={fieldStatus("reserve_start_date", f)}>
											<label htmlFor="reserve_start_date">Reservation Start</label>
											{f.errors.reserve_start_date && f.touched.reserve_start_date && (
												<div className="form__message">{f.errors.reserve_start_date}</div>
											)}
											<DateField
												name="lot.reserve_start_date"
												className="form__input"
												value={f.values.lot.reserve_start_date}
												onChange={f.setFieldValue}
												onBlur={f.setFieldTouched}
											/>
										</li>
										<li className={fieldStatus("reserve_end_date", f)}>
											<label htmlFor="reserve_end_date">Reservation End</label>
											{f.errors.reserve_end_date && f.touched.reserve_end_date && (
												<div className="form__message">{f.errors.reserve_end_date}</div>
											)}
											<DateField
												name="lot.reserve_end_date"
												className="form__input"
												value={f.values.lot.reserve_end_date}
												onChange={f.setFieldValue}
												onBlur={f.setFieldTouched}
											/>
										</li>
									</>
								)}
								{this.additionalFields("lot", "lot", f)}
								{this.renderAdditionalFields(f, "lot")}
							</ul>
						</AccordionItemPanel>
					</AccordionItem>
					{settings?.localFields?.feesTable && this.feesTable(f)}
					{_.get(settings, `localFields.lotPricing`) && (
						<AccordionItem uuid={"lotPricing"}>
							<AccordionItemHeading>
								<AccordionItemButton>
									<h3>Lot Pricing</h3>
								</AccordionItemButton>
							</AccordionItemHeading>
							<AccordionItemPanel>
								<ul className="lot__list">
									<li className={fieldStatus("takedown_date", f)}>
										<label htmlFor="takedown_date">Takedown</label>
										{f.errors.takedown_date && f.touched.takedown_date && (
											<div className="form__message">{f.errors.takedown_date}</div>
										)}
										<DateField
											name="lot.takedown_date"
											className="form__input"
											value={f.values.lot.takedown_date}
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
										/>
									</li>
									<li className={fieldStatus("base_price", f)}>
										<label htmlFor="base_price">Base Price</label>
										{f.errors.base_price && f.touched.base_price && (
											<div className="form__message">{f.errors.base_price}</div>
										)}
										<NumberField
											name="lot.base_price"
											type="text"
											className="form__input"
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.base_price}
											value={f.values.lot.base_price}
											thousandSeparator={true}
											prefix="$"
										/>
									</li>
									<li className={fieldStatus("premium", f)}>
										<label htmlFor="premium">Premium</label>
										{f.errors.premium && f.touched.premium && (
											<div className="form__message">{f.errors.premium}</div>
										)}
										<NumberField
											name="lot.premium"
											type="text"
											className="form__input"
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.premium}
											value={f.values.lot.premium}
											thousandSeparator={true}
											prefix="$"
										/>
									</li>
									<li className={fieldStatus("lot_premium_type", f)}>
										<label htmlFor="lot_premium_type">Premium Type</label>
										{f.errors.lot_premium_type && f.touched.lot_premium_type && (
											<div className="form__message">{f.errors.lot_premium_type}</div>
										)}
										<ReactSelect
											name={`lot.lot_premium_type`}
											options={_.map(this.props.payload.public.lot_premium_types, (v) => {
												return { value: v.id, label: `${v.name} (${v.id})` }
											})}
											value={f.values.lot.lot_premium_type}
											onBlur={f.setFieldTouched}
											onChange={f.setFieldValue}
										/>
									</li>
									<li className={fieldStatus("fence_fee", f)}>
										<label htmlFor="fence_fee">Fence Fee</label>
										{f.errors.fence_fee && f.touched.fence_fee && (
											<div className="form__message">{f.errors.fence_fee}</div>
										)}
										<NumberField
											name="lot.fence_fee"
											type="text"
											className="form__input"
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.fence_fee}
											value={f.values.lot.fence_fee}
											thousandSeparator={true}
											prefix="$"
											float={true}
										/>
									</li>
									{this.renderAdditionalFields(f, "lotPricing")}
								</ul>
							</AccordionItemPanel>
						</AccordionItem>
					)}
					{_.get(settings, `localFields.marketingFees`) && (
						<AccordionItem uuid={"marketingFees"}>
							<AccordionItemHeading>
								<AccordionItemButton>
									<h3>Marketing Fees</h3>
								</AccordionItemButton>
							</AccordionItemHeading>
							<AccordionItemPanel>
								<ul className="lot__list">{this.renderAdditionalFields(f, "marketingFees")}</ul>
							</AccordionItemPanel>
						</AccordionItem>
					)}
					{_.get(settings, `localFields.trueUp`) && (
						<AccordionItem uuid={"trueUp"}>
							<AccordionItemHeading>
								<AccordionItemButton>
									<h3>True Up</h3>
								</AccordionItemButton>
							</AccordionItemHeading>
							<AccordionItemPanel>
								<ul className="lot__list">{this.renderAdditionalFields(f, "trueUp")}</ul>
							</AccordionItemPanel>
						</AccordionItem>
					)}
					<AccordionItem uuid={"construction"}>
						<AccordionItemHeading>
							<AccordionItemButton>
								<h3>Construction</h3>
							</AccordionItemButton>
						</AccordionItemHeading>
						<AccordionItemPanel>
							<ul className="lot__list">
								<li className={fieldStatus("takedown_date", f)}>
									<label htmlFor="takedown_date">Takedown</label>
									{f.errors.takedown_date && f.touched.takedown_date && (
										<div className="form__message">{f.errors.takedown_date}</div>
									)}
									<DateField
										name="lot.takedown_date"
										className="form__input"
										value={f.values.lot.takedown_date}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
									/>
								</li>
								{settings?.optionalTimes && settings.optionalTimes.includes("formed_date") ? (
									<li className={fieldStatus("formed_date", f)}>
										<label htmlFor="formed_date">Formed Date</label>
										{f.errors.formed_date && f.touched.formed_date && (
											<div className="form__message">{f.errors.formed_date}</div>
										)}
										<DateField
											name="lot.formed_date"
											className="form__input"
											value={f.values.lot.formed_date}
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
										/>
									</li>
								) : null}
								<li className={fieldStatus("start_date", f)}>
									<label htmlFor="start_date">{settings?.renames?.start_date || "Start Date"}</label>
									{f.errors.start_date && f.touched.start_date && (
										<div className="form__message">{f.errors.start_date}</div>
									)}
									<DateField
										name="lot.start_date"
										className="form__input"
										value={f.values.lot.start_date}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
									/>
								</li>
								{settings?.optionalTimes && settings.optionalTimes.includes("framed_date") ? (
									<li className={fieldStatus("framed_date", f)}>
										<label htmlFor="framed_date">Framed Date</label>
										{f.errors.framed_date && f.touched.framed_date && (
											<div className="form__message">{f.errors.framed_date}</div>
										)}
										<DateField
											name="lot.framed_date"
											className="form__input"
											value={f.values.lot.framed_date}
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
										/>
									</li>
								) : null}
								{settings?.optionalTimes && settings.optionalTimes.includes("roofed_date") ? (
									<li className={fieldStatus("roofed_date", f)}>
										<label htmlFor="roofed_date">Roofed Date</label>
										{f.errors.roofed_date && f.touched.roofed_date && (
											<div className="form__message">{f.errors.roofed_date}</div>
										)}
										<DateField
											name="lot.roofed_date"
											className="form__input"
											value={f.values.lot.roofed_date}
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
										/>
									</li>
								) : null}
								{settings?.optionalTimes && settings.optionalTimes.includes("bricked_date") ? (
									<li className={fieldStatus("bricked_date", f)}>
										<label htmlFor="bricked_date">Bricked Date</label>
										{f.errors.bricked_date && f.touched.bricked_date && (
											<div className="form__message">{f.errors.bricked_date}</div>
										)}
										<DateField
											name="lot.bricked_date"
											className="form__input"
											value={f.values.lot.bricked_date}
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
										/>
									</li>
								) : null}
								{settings?.optionalTimes && settings.optionalTimes.includes("masonry_date") ? (
									<li className={fieldStatus("masonry_date", f)}>
										<label htmlFor="masonry_date">Masonry Date</label>
										{f.errors.masonry_date && f.touched.masonry_date && (
											<div className="form__message">{f.errors.masonry_date}</div>
										)}
										<DateField
											name="lot.masonry_date"
											className="form__input"
											value={f.values.lot.masonry_date}
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
										/>
									</li>
								) : null}
								{settings?.optionalTimes && settings.optionalTimes.includes("landscaped_date") ? (
									<li className={fieldStatus("landscaped_date", f)}>
										<label htmlFor="landscaped_date">Landscaped Date</label>
										{f.errors.landscaped_date && f.touched.landscaped_date && (
											<div className="form__message">{f.errors.landscaped_date}</div>
										)}
										<DateField
											name="lot.landscaped_date"
											className="form__input"
											value={f.values.lot.landscaped_date}
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
										/>
									</li>
								) : null}
								<li className={fieldStatus("complete_date", f)}>
									<label htmlFor="complete_date">Complete Date</label>
									{f.errors.complete_date && f.touched.complete_date && (
										<div className="form__message">{f.errors.complete_date}</div>
									)}
									<DateField
										name="lot.complete_date"
										className="form__input"
										value={f.values.lot.complete_date}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
									/>
								</li>
								<li className={fieldStatus("takedown_price", f)}>
									<label htmlFor="takedown_price">Takedown Price</label>
									{f.errors.takedown_price && f.touched.takedown_price && (
										<div className="form__message">{f.errors.takedown_price}</div>
									)}
									<NumberField
										name="lot.takedown_price"
										type="text"
										className="form__input"
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.takedown_price}
										value={f.values.lot.takedown_price}
										thousandSeparator={true}
										prefix="$"
										float={true}
									/>
								</li>
								<li className={fieldStatus("fence_fee", f)}>
									<label htmlFor="fence_fee">Fence Fee</label>
									{f.errors.fence_fee && f.touched.fence_fee && (
										<div className="form__message">{f.errors.fence_fee}</div>
									)}
									<NumberField
										name="lot.fence_fee"
										type="text"
										className="form__input"
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.fence_fee}
										value={f.values.lot.fence_fee}
										thousandSeparator={true}
										prefix="$"
										float={true}
									/>
								</li>
								{!_.get(settings, `localFields.lotPricing`) && (
									<>
										<li className={fieldStatus("base_price", f)}>
											<label htmlFor="base_price">Base Price</label>
											{f.errors.base_price && f.touched.base_price && (
												<div className="form__message">{f.errors.base_price}</div>
											)}
											<NumberField
												name="lot.base_price"
												type="text"
												className="form__input"
												onChange={f.setFieldValue}
												onBlur={f.setFieldTouched}
												touched={f.touched.base_price}
												value={f.values.lot.base_price}
												thousandSeparator={true}
												prefix="$"
											/>
										</li>
										<li className={fieldStatus("premium", f)}>
											<label htmlFor="premium">Premium</label>
											{f.errors.premium && f.touched.premium && (
												<div className="form__message">{f.errors.premium}</div>
											)}
											<NumberField
												name="lot.premium"
												type="text"
												className="form__input"
												onChange={f.setFieldValue}
												onBlur={f.setFieldTouched}
												touched={f.touched.premium}
												value={f.values.lot.premium}
												thousandSeparator={true}
												prefix="$"
											/>
										</li>
										<li className={fieldStatus("true_up", f)}>
											<label htmlFor="true_up">True Up</label>
											{f.errors.true_up && f.touched.true_up && (
												<div className="form__message">{f.errors.true_up}</div>
											)}
											<NumberField
												name="lot.true_up"
												type="text"
												className="form__input"
												onChange={f.setFieldValue}
												onBlur={f.setFieldTouched}
												touched={f.touched.true_up}
												value={f.values.lot.true_up}
											/>
										</li>
										<li className={fieldStatus("escalation", f)}>
											<label htmlFor="fee_escalation">Escalation</label>
											{f.errors.fee_escalation && f.touched.fee_escalation && (
												<div className="form__message">{f.errors.fee_escalation}</div>
											)}
											<NumberField
												name="lot.fee_escalation"
												type="text"
												className="form__input"
												onChange={f.setFieldValue}
												onBlur={f.setFieldTouched}
												touched={f.touched.fee_escalation}
												value={f.values.lot.fee_escalation}
												thousandSeparator={true}
												prefix={"$"}
											/>
										</li>
									</>
								)}
								<li className={fieldStatus("permit_number", f)}>
									<label htmlFor="permit_number">Permit Number</label>
									{f.errors.permit_number && f.touched.permit_number && (
										<div className="form__message">{f.errors.permit_number}</div>
									)}
									<Field name="lot.permit_number" type="text" className="form__input" />
								</li>
								<li className={fieldStatus("permit_issued", f)}>
									<label htmlFor="permit_issued">Permit Issued</label>
									{f.errors.permit_issued && f.touched.permit_issued && (
										<div className="form__message">{f.errors.permit_issued}</div>
									)}
									<DateField
										name="lot.permit_issued"
										className="form__input"
										value={f.values.lot.permit_issued}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
									/>
								</li>
								<li className={fieldStatus("permit_final", f)}>
									<label htmlFor="permit_final">Permit Final Date</label>
									{f.errors.permit_final && f.touched.permit_final && (
										<div className="form__message">{f.errors.permit_final}</div>
									)}
									<DateField
										name="lot.permit_final"
										className="form__input"
										value={f.values.lot.permit_final}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
									/>
								</li>
								{this.additionalFields("lot", "construction", f)}
								<li className={fieldStatus("construction_notes", f)}>
									<label htmlFor="construction_notes">Notes</label>
									{f.errors.construction_notes && f.touched.construction_notes && (
										<div className="form__message">{f.errors.construction_notes}</div>
									)}
									<TextArea
										name="lot.construction_notes"
										className="form__textarea"
										value={f.values.lot.construction_notes}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
									/>
								</li>
							</ul>
						</AccordionItemPanel>
					</AccordionItem>
					<AccordionItem uuid={"homeInfo"}>
						<AccordionItemHeading>
							<AccordionItemButton>
								<h3>Home Info</h3>
							</AccordionItemButton>
						</AccordionItemHeading>
						<AccordionItemPanel>
							<ul className="lot__list">
								<li className={fieldStatus("floorplan", f)}>
									<label htmlFor="floorplan">Floorplan</label>
									{f.errors.floorplan && f.touched.floorplan && (
										<div className="form__message">{f.errors.floorplan}</div>
									)}
									<ReactSelect
										name={`lot.floorplan`}
										//options={this.createOptions("floorplans", true)}
										clearable={true}
										options={this.floorplans()}
										value={f.values.lot.floorplan}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("elevation", f)}>
									<label htmlFor="elevation">Elevation</label>
									{f.errors.elevation && f.touched.elevation && (
										<div className="form__message">{f.errors.elevation}</div>
									)}
									<Field name="lot.elevation" type="text" className="form__input" />
								</li>
								<li className={fieldStatus("sqft", f)}>
									<label htmlFor="sqft">Square Feet</label>
									{f.errors.sqft && f.touched.sqft && (
										<div className="form__message">{f.errors.sqft}</div>
									)}
									<NumberField
										name="lot.sqft"
										type="text"
										className="form__input"
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.sqft}
										value={f.values.lot.sqft}
										thousandSeparator={true}
										numeric={true}
									/>
								</li>
								<li className={fieldStatus("stories", f)}>
									<label htmlFor="stories">Stories</label>
									{f.errors.stories && f.touched.stories && (
										<div className="form__message">{f.errors.stories}</div>
									)}
									<NumberField
										name="lot.stories"
										type="text"
										className="form__input"
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.stories}
										value={f.values.lot.stories}
										thousandSeparator={true}
										numeric={true}
									/>
								</li>
								<li className={fieldStatus("beds", f)}>
									<label htmlFor="beds">Beds</label>
									{f.errors.beds && f.touched.beds && (
										<div className="form__message">{f.errors.beds}</div>
									)}
									<NumberField
										name="lot.beds"
										type="text"
										className="form__input"
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.beds}
										value={f.values.lot.beds}
										thousandSeparator={true}
									/>
								</li>
								<li className={fieldStatus("full_baths", f)}>
									<label htmlFor="full_baths">Full Baths</label>
									{f.errors.full_baths && f.touched.full_baths && (
										<div className="form__message">{f.errors.full_baths}</div>
									)}
									<NumberField
										name="lot.full_baths"
										type="text"
										className="form__input"
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.full_baths}
										value={f.values.lot.full_baths}
										thousandSeparator={true}
										numeric={true}
									/>
								</li>
								<li className={fieldStatus("half_baths", f)}>
									<label htmlFor="half_baths">Half Baths</label>
									{f.errors.half_baths && f.touched.half_baths && (
										<div className="form__message">{f.errors.half_baths}</div>
									)}
									<NumberField
										name="lot.half_baths"
										type="text"
										className="form__input"
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.half_baths}
										value={f.values.lot.half_baths}
										thousandSeparator={true}
										numeric={true}
									/>
								</li>
								<li className={fieldStatus("garage", f)}>
									<label htmlFor="garage">Garage</label>
									{f.errors.garage && f.touched.garage && (
										<div className="form__message">{f.errors.garage}</div>
									)}
									<NumberField
										name="lot.garage"
										type="text"
										className="form__input"
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.garage}
										value={f.values.lot.garage}
									/>
								</li>
								<li className={fieldStatus("home_comments", f)}>
									<label htmlFor="home_comments">Home Comments</label>
									{f.errors.home_comments && f.touched.home_comments && (
										<div className="form__message">{f.errors.home_comments}</div>
									)}
									<TextArea
										name="lot.home_comments"
										className="form__textarea"
										value={f.values.lot.home_comments}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
									/>
								</li>
							</ul>
						</AccordionItemPanel>
					</AccordionItem>
					<AccordionItem uuid={"marketing"}>
						<AccordionItemHeading>
							<AccordionItemButton>
								<h3>Info for Marketing Website</h3>
							</AccordionItemButton>
						</AccordionItemHeading>
						<AccordionItemPanel>
							<ul className="lot__list">
								<li className={fieldStatus("marketing_price", f)}>
									<label htmlFor="price">Marketing Price</label>
									{f.errors.marketing_price && f.touched.marketing_price && (
										<div className="form__message">{f.errors.marketing_price}</div>
									)}
									<NumberField
										name="lot.marketing_price"
										type="text"
										className="form__input"
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.marketing_price}
										value={f.values.lot.marketing_price}
										thousandSeparator={true}
										numeric={true}
									/>
								</li>
								<li className={fieldStatus("was_price", f)}>
									<label htmlFor="price">Was Price</label>
									{f.errors.was_price && f.touched.was_price && (
										<div className="form__message">{f.errors.was_price}</div>
									)}
									<NumberField
										name="lot.was_price"
										type="text"
										className="form__input"
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.was_price}
										value={f.values.lot.was_price}
										thousandSeparator={true}
										numeric={true}
									/>
								</li>
								<li className={fieldStatus("in_feed", f)}>
									<label htmlFor="in_feed">In Builder Feed</label>
									{_.get(this.state, `data.lot.in_feed`) ? "Yes" : "No"}
								</li>
								<li className={fieldStatus("in_feed_manual", f)}>
									<label htmlFor="in_feed_manual">In Feed</label>
									{f.errors.in_feed_manual && f.touched.in_feed_manual && (
										<div className="form__message">{f.errors.in_feed_manual}</div>
									)}
									<ReactSelect
										name={`lot.in_feed_manual`}
										options={[
											{ value: 0, label: "No" },
											{ value: 1, label: "Yes" },
										]}
										value={f.values.lot.in_feed_manual}
										onBlur={f.setFieldTouched}
										clearable
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("feed_address", f)}>
									<label htmlFor="feed_address">Feed Address</label>
									{f.errors.feed_address && f.touched.feed_address && (
										<div className="form__message">{f.errors.feed_address}</div>
									)}
									<Field name="lot.feed_address" type="text" className="form__input" />
								</li>
								<li className={fieldStatus("move_in_date", f)}>
									<label htmlFor="move_in_date">Move In Date</label>
									{f.errors.move_in_date && f.touched.move_in_date && (
										<div className="form__message">{f.errors.move_in_date}</div>
									)}
									<DateField
										name="lot.move_in_date"
										className="form__input"
										value={f.values.lot.move_in_date}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
									/>
								</li>
								<li className={fieldStatus("marketing_description", f)}>
									<label htmlFor="marketing_description">Marketing Description</label>
									{f.errors.marketing_description && f.touched.marketing_description && (
										<div className="form__message">{f.errors.marketing_description}</div>
									)}
									<HTMLEditor
										name={`lot.marketing_description`}
										className="form__textarea"
										value={f.values.lot.marketing_description}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
									/>
								</li>
								<li className={fieldStatus("mls", f)}>
									<label htmlFor="mls">MLS Link</label>
									{f.errors.mls && f.touched.mls && (
										<div className="form__message">{f.errors.mls}</div>
									)}
									<Field name="lot.mls" type="text" className="form__input" />
								</li>
								<li className={fieldStatus("is_promo", f)}>
									<label htmlFor="is_promo">In Promo</label>
									{f.errors.is_promo && f.touched.is_promo && (
										<div className="form__message">{f.errors.is_promo}</div>
									)}
									<ReactSelect
										name={`lot.is_promo`}
										options={[
											{ value: 0, label: "No" },
											{ value: 1, label: "Yes" },
										]}
										value={f.values.lot.is_promo}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("incentive", f)}>
									<label htmlFor="incentive">Incentive</label>
									{f.errors.incentive && f.touched.incentive && (
										<div className="form__message">{f.errors.incentive}</div>
									)}
									<Field name="lot.incentive" type="text" className="form__input" />
								</li>
								<li
									className={`${fieldStatus(
										"open_house",
										f,
										false,
										false,
										true
									)} p-4 border-dashed border-gray-300`}>
									<div
										className="datepicker__close !right-4 !top-4"
										onClick={() => f.setFieldValue("lot.open_house", null)}>
										X
									</div>
									<label htmlFor="open_house">Open Houses</label>
									{f.errors.open_house && f.touched.open_house && (
										<div className="form__message">{f.errors.open_house}</div>
									)}
									<TableRowField
										align="left"
										appendUser={true}
										delete={true}
										//initRow={true}
										fields={[
											{
												type: "datetimepicker",
												name: "times",
												header: "Date/Time",
											},
											{
												type: "text",
												name: "notes",
												header: "Notes",
											},
										]}
										data={f.values.lot.open_house}
										onChange={(v) => f.setFieldValue("lot.open_house", v)}
									/>
								</li>
								<li className="form__listItem form__listItem--imageZone">
									<p>
										<label htmlFor="home_comments" className="inline">
											Home Images
										</label>
										<span
											className="pl-5 text-xs text-blue font-bold cursor-pointer"
											onClick={() => this.zipImages()}>
											<i className="fa-solid fa-download mr-1"></i>Download Images
										</span>
									</p>
									<p className="mid infoNote py-2 m-0">
										<i className={`fas fa-info-circle`} />
										Before uploading images, please select a category. If no category is selected
										the type will be unknown.
									</p>
									<ReactSelect
										className="mb-2 mt-1 w-3/12"
										key={`image_type`}
										name={`image_type`}
										options={[
											{ value: "elevation", label: "Elevation" },
											{ value: "interior", label: "Interior" },
											{ value: "exterior", label: "Exterior" },
											{ value: "floorplan", label: "Floorplan" },
										]}
										value={this.state.image_type}
										onBlur={() => {}}
										onChange={(k, v) => {
											this.setState({ image_type: v })
										}}
									/>
									<div className="imageZone">
										<Dropzone
											multiple={true}
											onDrop={(files) => {
												this.onImageDrop(files, f)
											}}>
											{({ getRootProps, getInputProps }) => (
												<section className="dropzone">
													<div {...getRootProps()} className="dropbox__cont imageZone__cont">
														<input {...getInputProps()} />
														<p className="dropzone__action imageZone__action">
															Drag 'n' drop images here, or click to select images.
														</p>
													</div>
												</section>
											)}
										</Dropzone>
										<div className="imageZone__existing">
											{this.state.selectedImages.length > 0 && (
												<div className="flex justify-end pb-4 text-blue text-xl">
													<i
														className="fa-regular fa-ban cursor-pointer text-base"
														onClick={() => this.setState({ selectedImages: [] })}></i>
													<i
														className="fa-regular fa-up-to-line cursor-pointer pl-2"
														onClick={() => {
															let orig = _.clone(this.state.images)
															let images = _.clone(this.state.images)
															_.forEach(this.state.selectedImages, (k) => {
																images.unshift(orig[k])
															})
															images = _.uniq(images)
															this.setState({ images, selectedImages: [] })
															f.values.lot.images = images
														}}></i>
													<i
														className="fa-regular fa-down-to-line pl-2 cursor-pointer"
														onClick={() => {
															let orig = _.clone(this.state.images)
															let images = _.clone(this.state.images)
															_.forEach(this.state.selectedImages, (k) => {
																images.push(orig[k])
															})
															images.reverse()
															images = _.uniq(images)
															images.reverse()
															this.setState({ images, selectedImages: [] })
															f.values.lot.images = images
														}}></i>
												</div>
											)}
											<ul className="imageZone__list">{this.compileThumbs(f)}</ul>
										</div>
									</div>
								</li>
							</ul>
						</AccordionItemPanel>
					</AccordionItem>
					<AccordionItem uuid={"buyers"}>
						<AccordionItemHeading>
							<AccordionItemButton>
								<h3>Buyer Info</h3>
							</AccordionItemButton>
						</AccordionItemHeading>
						<AccordionItemPanel className="accordion__panel accordion__panel--nest">
							<Accordion allowZeroExpanded={true}>{this.renderSales(f)}</Accordion>
						</AccordionItemPanel>
					</AccordionItem>
					<AccordionItem uuid={"priceParticipation"}>
						<AccordionItemHeading>
							<AccordionItemButton>
								<h3>Price Participation</h3>
							</AccordionItemButton>
						</AccordionItemHeading>
						<AccordionItemPanel>
							<ul className="lot__list">
								<li className={fieldStatus("is_price_participation", f)}>
									<label htmlFor="is_price_participation">Price Participation Lot</label>
									{f.errors.is_price_participation && f.touched.is_price_participation && (
										<div className="form__message">{f.errors.is_price_participation}</div>
									)}
									<ReactSelect
										name={`lot.is_price_participation`}
										options={[
											{ value: 0, label: "No" },
											{ value: 1, label: "Yes" },
										]}
										value={f.values.lot.is_price_participation}
										onBlur={f.setFieldTouched}
										onChange={f.setFieldValue}
									/>
								</li>
								<li className={fieldStatus("date_hud_closing", f)}>
									<label htmlFor="date_hud_closing">Price Participation Closing Date</label>
									{f.errors.date_hud_closing && f.touched.date_hud_closing && (
										<div className="form__message">{f.errors.date_hud_closing}</div>
									)}
									<DateField
										name={`lot.date_hud_closing`}
										className="form__input"
										value={f.values && f.values.lot && f.values.lot.date_hud_closing}
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
									/>
								</li>
								<li className={fieldStatus("price_partic_percent", f)}>
									<label htmlFor="price_partic_percent">Price Participation Percent</label>
									{f.errors.price_partic_percent && f.touched.price_partic_percent && (
										<div className="form__message">{f.errors.price_partic_percent}</div>
									)}
									<NumberField
										name="lot.price_partic_percent"
										type="text"
										className="form__input"
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.price_partic_percent}
										value={f.values.lot.price_partic_percent}
										thousandSeparator={true}
										numeric={true}
									/>
								</li>
								<li className={fieldStatus("price_partic_fee", f)}>
									<label htmlFor="price_partic_fee">Price Participation Fee</label>
									{f.errors.price_partic_fee && f.touched.price_partic_fee && (
										<div className="form__message">{f.errors.price_partic_fee}</div>
									)}
									<NumberField
										name="lot.price_partic_fee"
										type="text"
										className="form__input"
										onChange={f.setFieldValue}
										onBlur={f.setFieldTouched}
										touched={f.touched.price_partic_fee}
										value={f.values.lot.price_partic_fee}
										thousandSeparator={true}
										float={true}
									/>
								</li>
								<li className={fieldStatus("dot_partial_release", f)}>
									<label htmlFor="dot_partial_release">Partial Release of Deed Rec #</label>
									{f.errors.dot_partial_release && f.touched.dot_partial_release && (
										<div className="form__message">{f.errors.dot_partial_release}</div>
									)}
									<Field name="lot.dot_partial_release" type="text" className="form__input" />
								</li>
							</ul>
						</AccordionItemPanel>
					</AccordionItem>
					<AccordionItem uuid={"appraisalDistrict"}>
						<AccordionItemHeading>
							<AccordionItemButton>
								<h3>Appraisal District</h3>
							</AccordionItemButton>
						</AccordionItemHeading>
						<AccordionItemPanel>
							<ul className="lot__list">
								<li className={fieldStatus("cad_id", f)}>
									<label htmlFor="cad_id">CAD ID</label>#{this.props.data.cad_id}
								</li>
								<li className={fieldStatus("cad_geo_id", f)}>
									<label htmlFor="cad_geo_id">CAD Geo ID</label>#{this.props.data.cad_geo_id}
								</li>
							</ul>
						</AccordionItemPanel>
					</AccordionItem>
					{showARC && (
						<AccordionItem uuid={"arc_data"}>
							<AccordionItemHeading>
								<AccordionItemButton>
									<h3>ARC Data</h3>
								</AccordionItemButton>
							</AccordionItemHeading>
							<AccordionItemPanel>
								<div className="flex justify-end">
									{this.downloadApproval(f)}
									{this.resendApprovalLetter(f)}
									{this.removeARCApprovalButton(f)}
								</div>
								<ul className="lot__list">
									<li className={fieldStatus("floorplan", f)}>
										<label htmlFor="floorplan">Floorplan</label>
										{f.errors.floorplan && f.touched.floorplan && (
											<div className="form__message">{f.errors.floorplan}</div>
										)}
										<ReactSelect
											name={`lot.floorplan`}
											//options={this.createOptions("floorplans", true)}
											clearable={true}
											options={this.floorplans()}
											value={f.values.lot.floorplan}
											onBlur={f.setFieldTouched}
											onChange={f.setFieldValue}
										/>
									</li>
									<li className={fieldStatus("elevation", f)}>
										<label htmlFor="elevation">Elevation</label>
										{f.errors.elevation && f.touched.elevation && (
											<div className="form__message">{f.errors.elevation}</div>
										)}
										<Field name="lot.elevation" type="text" className="form__input" />
									</li>
									<li className={fieldStatus("sqft", f)}>
										<label htmlFor="sqft">Square Feet</label>
										{f.errors.sqft && f.touched.sqft && (
											<div className="form__message">{f.errors.sqft}</div>
										)}
										<NumberField
											name="lot.sqft"
											type="text"
											className="form__input"
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.sqft}
											value={f.values.lot.sqft}
											thousandSeparator={true}
											numeric={true}
										/>
									</li>
									{f?.values?.lot?.arc_data?.approval_date ? (
										<li className={fieldStatus("lot_approval_date", f)}>
											<label htmlFor="lot_approval_date">Lot Approval Date</label>
											{moment.unix(f.values.lot.arc_data.approval_date).format("MM/DD/YYYY")}
										</li>
									) : null}
									<li className={fieldStatus("arc_approved", f)}>
										<label htmlFor="arc_approved">Full ARC Approval</label>
										{f.errors.arc_approved && f.touched.arc_approved && (
											<div className="form__message">{f.errors.arc_approved}</div>
										)}
										<ReactSelect
											name={`lot.arc_approved`}
											options={[
												{ value: 0, label: "No" },
												{ value: 1, label: "Yes" },
											]}
											value={f.values.lot.arc_approved}
											onBlur={f.setFieldTouched}
											onChange={f.setFieldValue}
										/>
									</li>
									<li className={fieldStatus("conditional_approval", f)}>
										<label htmlFor="conditional_approval">Conditionally Approved?</label>
										{f.values?.lot?.arc_data?.conditional_approval ? "Yes" : "No"}
									</li>
									<li className={fieldStatus("brick", f)}>
										<label htmlFor="brick">Brick</label>
										{f.errors.brick && f.touched.brick && (
											<div className="form__message">{f.errors.brick}</div>
										)}
										{this.getMaterialField("brick", 1, f)}
									</li>
									<li className={fieldStatus("accent_color", f)}>
										<label htmlFor="accent_color">Accent Color</label>
										{f.errors.accent_color && f.touched.accent_color && (
											<div className="form__message">{f.errors.accent_color}</div>
										)}
										{this.getMaterialField("accent_color", 6, f)}
									</li>
									<li className={fieldStatus("garage_color", f)}>
										<label htmlFor="garage_color">Garage Color</label>
										{f.errors.garage_color && f.touched.garage_color && (
											<div className="form__message">{f.errors.garage_color}</div>
										)}
										{this.getMaterialField("garage_color", 7, f)}
									</li>
									<li className={fieldStatus("roof_color", f)}>
										<label htmlFor="roof_color">Roof Color</label>
										{f.errors.roof_color && f.touched.roof_color && (
											<div className="form__message">{f.errors.roof_color}</div>
										)}
										{this.getMaterialField("roof_color", 8, f)}
									</li>
									<li className={fieldStatus("siding", f)}>
										<label htmlFor="siding">Siding Color</label>
										{f.errors.siding && f.touched.siding && (
											<div className="form__message">{f.errors.siding}</div>
										)}
										{this.getMaterialField("siding", 11, f)}
									</li>
									<li className={fieldStatus("siding_type", f)}>
										<label htmlFor="siding_type">Siding Type</label>
										{f.errors.siding_type && f.touched.siding_type && (
											<div className="form__message">{f.errors.siding_type}</div>
										)}
										{this.getMaterialField("siding_type", 3, f)}
									</li>
									<li className={fieldStatus("stone", f)}>
										<label htmlFor="stone">Stone</label>
										{f.errors.stone && f.touched.stone && (
											<div className="form__message">{f.errors.stone}</div>
										)}
										{this.getMaterialField("stone", 4, f)}
									</li>
									<li className={fieldStatus("trim", f)}>
										<label htmlFor="trim">Trim</label>
										{f.errors.trim && f.touched.trim && (
											<div className="form__message">{f.errors.trim}</div>
										)}
										{this.getMaterialField("trim", 5, f)}
									</li>
									<li className={fieldStatus("stucco", f)}>
										<label htmlFor="stucco">Stucco</label>
										{f.errors.stucco && f.touched.stucco && (
											<div className="form__message">{f.errors.stucco}</div>
										)}
										{this.getMaterialField("stucco", 2, f)}
									</li>
									{_.has(f, `values.lot.arc_data.approval_comments`) && (
										<li className={fieldStatus("approval_comments", f)}>
											<label htmlFor="lot.arc_data.approval_comments">Approval Comments</label>
											{f.errors.approval_comments && f.touched.approval_comments && (
												<div className="form__message">{f.errors.approval_comments}</div>
											)}
											<TextArea
												name="lot.arc_data.approval_comments"
												className="form__textarea"
												value={f.values.lot.arc_data.approval_comments}
												onChange={f.setFieldValue}
												onBlur={f.setFieldTouched}
											/>
										</li>
									)}
									<li className={fieldStatus("fr", f)}>
										<label htmlFor="lot.arc_data.fr">Final Review</label>
										{f.errors.fr && f.touched.fr && (
											<div className="form__message">{f.errors.fr}</div>
										)}
										<ReactSelect
											name={`lot.arc_data.fr`}
											options={[
												{ value: false, label: "Rejected" },
												{ value: true, label: "Approved" },
											]}
											value={f.values?.lot?.arc_data?.fr}
											onBlur={f.setFieldTouched}
											onChange={f.setFieldValue}
										/>
									</li>
									<li className={fieldStatus("max_pad_depth", f)}>
										<label htmlFor="max_pad_depth">Max Pad Depth</label>
										{f.errors.max_pad_depth && f.touched.max_pad_depth && (
											<div className="form__message">{f.errors.max_pad_depth}</div>
										)}
										<NumberField
											name="lot.max_pad_depth"
											type="text"
											className="form__input"
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.max_pad_depth}
											value={f.values.lot.max_pad_depth}
											thousandSeparator={true}
											float={true}
											decimals={2}
										/>
									</li>
									<li className={fieldStatus("masonry_percent", f)}>
										<label htmlFor="masonry_percent">Masonry %</label>
										{f.errors.masonry_percent && f.touched.masonry_percent && (
											<div className="form__message">{f.errors.masonry_percent}</div>
										)}
										<NumberField
											name="lot.masonry_percent"
											type="text"
											className="form__input"
											onChange={f.setFieldValue}
											onBlur={f.setFieldTouched}
											touched={f.touched.masonry_percent}
											value={f.values.lot.masonry_percent}
										/>
									</li>
									<li className={fieldStatus("plan_file", f)}>
										<label htmlFor="plan_file">Plan File {arcFile}</label>
										<input
											name="lot.filesToUpload.plan_file"
											type="file"
											id="lot.filesToUpload.plan_file"
											className="noBorder"
											onChange={(event) => {
												f.setFieldValue(
													"lot.filesToUpload.plan_file",
													event.currentTarget.files[0]
												)
											}}
										/>
									</li>
								</ul>
								{this.documentsList()}
							</AccordionItemPanel>
						</AccordionItem>
					)}

					<AccordionItem uuid={"general_documents"}>
						<AccordionItemHeading>
							<AccordionItemButton>
								<h3>General Documents</h3>
							</AccordionItemButton>
						</AccordionItemHeading>
						<AccordionItemPanel>
							{this.renderGeneralDocuments(f)}
						</AccordionItemPanel>
					</AccordionItem>

				</Accordion>
				{submitButton}
			</Form>
		)
	}

	openActionModal = (name) => {
		this.setState({
			[name]: true,
			//data: data,
		})
	}

	notify = (d, name) => {
		//return
		if (d.status == 200) {
			toast.success(d.message)
			this.setState({
				[name]: false,
			})
			this.props.getPayload()
		} else {
			toast.error(d.message)
		}
	}

	onImageDrop = async (files, f) => {
		let paths = []
		if (!this.state.image_type) {
			toast.error("Please select image type")
			return
		}
		for (let v of files) {
			try {
				const response = await request
					.post(`${settings.ep}/inputHomeImage`)
					.attach(v.name, v)
					.set("Authorization", `Bearer ${localStorage.user}`)
					.field(
						"attributes",
						JSON.stringify({
							lot_id: this.props.data.id,
							sale_id: this.props.data.sale_id,
							image_type: this.state.image_type,
						})
					)
				if (response && response.status == 200) {
					let resp = response.body
					paths = resp?.data
					let state = _.cloneDeep(this.state)
					state.images = resp.data
					this.setState(state, () => {
						//console.log(this.state)
					})
				}
			} catch (e) {
				console.log(e)
			}
		}
		f.setFieldValue("lot.images", paths)
	}

	saleButtons = (data) => {
		if (data.closing_date) {
			return ""
		}
		if (data.sale_id) {
			return (
				<>
					<li style={{ marginRight: "10px" }}>Add: </li>
					<li>
						<a onClick={() => this.openActionModal("bustoutModal")} className="btn">
							Cancel
						</a>
					</li>
					<li>
						<a onClick={() => this.openActionModal("closingModal")} className="btn">
							Closing
						</a>
					</li>
					<li>
						<a onClick={() => this.openActionModal("transferModal")} className="btn">
							Transfer
						</a>
					</li>
				</>
			)
		} else {
			return (
				<>
					<li style={{ marginRight: "10px" }}>Add: </li>
					<li>
						<a onClick={() => this.openActionModal("contractModal")} className="btn">
							Sale
						</a>
					</li>
				</>
			)
		}
	}

	zipImages = async () => {
		this.props.loadingStatus(true)
		// zip this lots images using fflate library
		// first using fetch, get buffers of all the images
		// then zip them
		// then download them
		let images = this.state.images
		if (this.state.selectedImages.length > 0) {
			//? They only want to download selected images
			let selected = []
			_.forEach(images, (v, k) => {
				if (this.state.selectedImages.includes(k)) {
					selected.push(v)
				}
			})
			images = selected
		} // else they want to download all images
		let buffers = []
		for (let v of images) {
			try {
				let url = "https://cors.pipsy.io/"
				if (v?.url?.charAt(0) === "/") {
					// on our s3
					url += `${settings.s3}${v.url}`
				} else {
					// on the builder
					if (v.url.includes("?")) {
						let split = v.url.split("?")
						v.url = split[0]
					}
					url += v.url
				}
				let response = await fetch(url)
				let buffer = await response.arrayBuffer()
				let filename = v.url.split("/").pop()
				buffers.push({
					buffer: new Uint8Array(buffer),
					name: filename,
				})
			} catch (e) {
				console.log(e)
			}
		}
		// Now create the structure for the zip
		//let zip = new fflate.Zip()
		let store = {}
		for (let i = 0; i < buffers.length; i++) {
			store[buffers[i].name] = buffers[i].buffer
			//zip.add(buffers[i].buffer, { name: buffers[i].filename })
		}
		const zip = fflate.zipSync(store)
		// Now download the zip
		let url = URL.createObjectURL(new Blob([zip]))
		let a = document.createElement("a")
		a.href = url
		a.download = `${this.props.data.address}-images.zip`
		a.click()
		URL.revokeObjectURL(url)
		this.props.loadingStatus(false)
	}

	buildLog = () => {
		let d = this.state.data.lot
		let log = d.log

		let logEntries = _.map(log, (v, k) => {
			let action
			if (v.type === "email") {
				action = (
					<a
						className="btn text-sm"
						onClick={async () => {
							let resp = await submitDataAsync("mainIngest", { action: "resendEmail", data: v.details })
							if (resp.status === 200) {
								toast.success(resp.message)
							} else {
								toast.error(resp.message)
							}
						}}>
						Resend Email
					</a>
				)
			} else if (v.type === "snapshot") {
				action = (
					<a
						className="btn text-sm"
						onClick={async () => {
							let thisLog = _.clone(d.log)
							thisLog = _.filter(thisLog, (v) => v.type === "snapshot")
							let against
							if (k === thisLog.length - 1) {
								against = d
							} else if (thisLog[k - 1]) {
								against = thisLog[k - 1].details
							} else if (thisLog[0]) {
								against = thisLog[0].details
							}
							this.setState({ diffData: { open: v.details, against }, diffViewer: true })
						}}>
						View Diff
					</a>
				)
			}
			return {
				type: helpers.snakeToTitle(v.type),
				message: v.excerpt,
				action,
				date: moment.unix(v.addedDate).format("MM/DD/YY h:mm a"),
			}
		})

		return (
			<div>
				<h2 className="pt-0">Lot Log</h2>
				<table className="full dataTable !mt-12 text-sm">
					<thead className="">
						<tr>
							<th>Type</th>
							<th>Message</th>
							<th>Action(s)</th>
							<th>Date</th>
						</tr>
					</thead>
					<tbody>
						{logEntries.map((entry, index) => (
							<tr key={index}>
								<td>{entry.type}</td>
								<td>{entry.message}</td>
								<td>{entry.action}</td>
								<td>{entry.date}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		)
	}

	diffViewer = () => {
		let d = this.state.diffData
		// Determine the difference between previous and open:
		// Find differences between previous and open states
		let differences = {}

		const _ = require("lodash")

		const findDifferences = (prev, curr) => {
			let skips = ["coordinates", "log", "modifiedDate"]
			prev = _.omit(prev, skips)
			curr = _.omit(curr, skips)

			const flatten = (obj, path = "", result = {}) => {
				if (typeof obj === "object" && obj !== null && !Array.isArray(obj)) {
					Object.keys(obj).forEach((key) => {
						const newPath = path ? `${path}.${key}` : key
						flatten(obj[key], newPath, result)
					})
				} else if (Array.isArray(obj)) {
					obj.forEach((item, index) => {
						const newPath = `${path}[${index}]`
						flatten(item, newPath, result)
					})
				} else {
					result[path] = obj
				}
				return result
			}

			const prevFlat = flatten(prev)
			const currFlat = flatten(curr)

			const allPaths = new Set([...Object.keys(prevFlat), ...Object.keys(currFlat)])

			const differences = {}
			allPaths.forEach((path) => {
				const prevValue = prevFlat[path]
				const currValue = currFlat[path]
				if ((prevValue !== currValue || path in prevFlat !== path in currFlat) && (prevValue || currValue)) {
					differences[path] = {
						previous: prevValue,
						current: currValue,
					}
				}
			})

			return differences
		}
		differences = findDifferences(d.open, d.against)
		differences = helpers.translateIdsToNames(differences, this.props.payload.public)
		// now run common translations converting IDs to names
		//differences = helpers.translateIdsToNames(di)
		if (d) {
			return (
				<table className="w-full dataTable !mt-12 text-sm">
					<thead>
						<tr>
							<th>Field</th>
							<th>Previous</th>
							<th>Next</th>
						</tr>
					</thead>
					<tbody>
						{_.map(differences, (v, k) => {
							return (
								<tr key={k}>
									<td>{helpers.snakeToTitle(k)}</td>
									<td>{v.previous}</td>
									<td>{v.current}</td>
								</tr>
							)
						})}
					</tbody>
				</table>
			)
		} else {
			return null
		}
	}

	documentsList = () => {
		if (!this.state.data.lot?.arc_history) return null
		let ret = []
		_.forEach(this.state.data.lot.arc_history, (v, k) => {
			let cond = v?.data?.conditional_file
			let plan = v?.data?.plan_file
			let approval = v?.data?.approval_file
			let buttons = []
			if (cond) {
				buttons.push(
					<a className="btn tiny !bg-orange-600 mr-2" href={`${settings.s3}${cond}`} target="_blank">
						Conditional Approval
					</a>
				)
			}
			if (plan) {
				buttons.push(
					<a className="btn tiny mr-2" href={`${settings.s3}${plan}`} target="_blank">
						Plan File
					</a>
				)
			}
			if (approval) {
				buttons.push(
					<a className="btn tiny !bg-green-700 mr-2" href={`${settings.s3}${approval}`} target="_blank">
						Full Approval
					</a>
				)
			}
			if (buttons.length) {
				ret.push(
					<tr key={k}>
						<td className="text-sm">{moment.unix(v.addedDate).format("MM/DD/YY")}</td>
						<td className="text-sm">{v.action}</td>
						<td>{buttons}</td>
					</tr>
				)
			}
		})

		return (
			<div className="mt-5">
				<h3>ARC Documents History</h3>
				<table className="dataTable tight">
					<thead>
						<tr className="font-bold">
							<th className="w-[150px]">Snapshot Date</th>
							<th className="w-[200px]">Action</th>
							<th>Files</th>
						</tr>
					</thead>
					<tbody>{ret}</tbody>
				</table>
			</div>
		)
	}

	renderGeneralDocuments = (f) => {
		return (
			<div>
				<div className="mb-4">
					<Dropzone
						multiple={true}
						onDrop={(files) => {
							this.onDocumentDrop(files, f)
						}}>
						{({ getRootProps, getInputProps }) => (
							<section className="dropzone">
								<div {...getRootProps()} className="dropbox__cont">
									<input {...getInputProps()} />
									<p className="dropzone__action">
										Drag 'n' drop documents here, or click to select files.
									</p>
								</div>
							</section>
						)}
					</Dropzone>
				</div>
				{this.renderDocumentGrid()}
			</div>
		)
	}

	onDocumentDrop = async (files, f) => {
		for (let file of files) {
			try {
				const response = await request
					.post(`${settings.ep}/addLotDoc`)
					.attach('file', file)
					.set("Authorization", `Bearer ${localStorage.user}`)
					.field('lot_id', this.props.data.id)
				
				if (response.status === 200 && response.body.data) {
					toast.success(`${file.name} uploaded successfully`)
					this.setState({
						lotDocuments: response.body.data
					})
				} else {
					toast.error(`Failed to upload ${file.name}`)
				}
			} catch (error) {
				console.error('Upload error:', error)
				toast.error(`Error uploading ${file.name}`)
			}
		}
	}

	deleteDocument = async (docUrl, fileName) => {
		try {
			const response = await request
				.post(`${settings.ep}/deleteLotDoc`)
				.set("Authorization", `Bearer ${localStorage.user}`)
				.send({
					url: docUrl,
					lot_id: this.props.data.id
				})
			
			if (response.status === 200) {
				toast.success(`${fileName} deleted successfully`)
				this.setState({
					lotDocuments: this.state.lotDocuments.filter(doc => doc.url !== docUrl)
				})
			} else {
				toast.error(`Failed to delete ${fileName}`)
			}
		} catch (error) {
			console.error('Delete error:', error)
			toast.error(`Error deleting ${fileName}`)
		}
	}

	getFileType = (fileName) => {
		if (!fileName) return 'DOC'
		const extension = fileName.split('.').pop().toUpperCase()
		return extension
	}

	getFileIcon = (fileType) => {
		const iconMap = {
			'PDF': '📄',
			'JPG': '🖼️',
			'JPEG': '🖼️',
			'PNG': '🖼️',
			'GIF': '🖼️',
			'DOC': '📝',
			'DOCX': '📝',
			'XLS': '📊',
			'XLSX': '📊',
			'TXT': '📄',
			'ZIP': '🗂️',
			'RAR': '🗂️'
		}
		return iconMap[fileType] || '📄'
	}

	onDocumentGridChange = (sourceId, sourceIndex, targetIndex) => {
		const nextState = swap(this.state.lotDocuments, sourceIndex, targetIndex)
		this.setState({ lotDocuments: nextState, isDragging: true })
		this.updateDocumentOrder(nextState)
		
		// Reset drag state after a short delay
		setTimeout(() => {
			this.setState({ isDragging: false })
		}, 200)
	}

	updateDocumentOrder = async (orderedDocs) => {
		try {
			const response = await request
				.post(`${settings.ep}/updateLotDocOrder`)
				.set("Authorization", `Bearer ${localStorage.user}`)
				.send({
					lot_id: this.props.data.id,
					documents: orderedDocs
				})
			
			if (response.status !== 200) {
				toast.error('Failed to update document order')
			}
		} catch (error) {
			console.error('Update order error:', error)
			toast.error('Error updating document order')
		}
	}

	renderDocumentGrid = () => {
		if (!this.state.lotDocuments || this.state.lotDocuments.length === 0) {
			return (
				<div className="text-center text-gray-500 py-4">
					No documents uploaded yet
				</div>
			)
		}

		return (
			<GridContextProvider onChange={this.onDocumentGridChange}>
				<GridDropZone
					id="documentGrid"
					boxesPerRow={6}
					rowHeight={120}
					style={{ height: Math.ceil(this.state.lotDocuments.length / 6) * 120 + 20 }}>
					{this.state.lotDocuments.map((doc, index) => {
						const fileType = this.getFileType(doc.filename)
						const fileIcon = this.getFileIcon(fileType)
						
						return (
							<GridItem key={doc.url}>
								<div className="relative bg-gray-50 p-3 rounded-lg text-center hover:bg-gray-100 transition-colors cursor-move" style={{ height: '100px', margin: '5px' }}>
									<button
										className="absolute top-1 right-1 w-5 h-5 bg-red-500 text-white rounded-full text-xs hover:bg-red-600 flex items-center justify-center"
										style={{ zIndex: 1000 }}
										onMouseDown={(e) => {
											e.preventDefault()
											e.stopPropagation()
										}}
										onClick={(e) => {
											e.preventDefault()
											e.stopPropagation()
											this.deleteDocument(doc.url, doc.filename)
										}}
										title={`Delete ${doc.filename}`}>
										×
									</button>
									<div 
										className="block h-full"
										onClick={(e) => {
											e.preventDefault()
											e.stopPropagation()
											if (!this.state.isDragging) {
												window.open(`${settings.s3}${doc.url}`, '_blank')
											}
										}}
										onMouseDown={(e) => e.preventDefault()}
										style={{ userSelect: 'none' }}>
										<div className="text-2xl mb-1">{fileIcon}</div>
										<div className="text-xs font-semibold text-gray-700 mb-1">{fileType}</div>
										<div className="text-xs text-gray-600 break-words overflow-hidden" style={{ maxHeight: '20px' }}>{doc.filename}</div>
									</div>
								</div>
							</GridItem>
						)
					})}
				</GridDropZone>
			</GridContextProvider>
		)
	}

	render() {
		const { open } = this.props
		if (this.state.ready) {
			let d = this.state.data.lot
			let logButton
			if (Array.isArray(d.log) && d.log.length > 0) {
				logButton = (
					<li
						className="mr-4"
						onClick={() => {
							this.setState({ logModal: true })
						}}>
						<a className="btn text-xs">View Log</a>
					</li>
				)
			}
			return (
				<Modal
					open={open}
					onClose={this.closeModal}
					center
					classNames={{ modal: "lot__modal", closeButton: "lot__close" }}>
					<div id="lotmodal">
						<div className="lot__modalCont">
							<div className="lot__modalLeft">
								<h3 style={{ marginBottom: 0 }}>Lot Management: {this.state.data.lot.address}</h3>
								<p className="lot__status">
									Sale Status: {this.state.data.lot.sale_status} | Const Status:{" "}
									{this.state.data.lot.const_status}
								</p>
							</div>
							<div className="lot__actions">
								<ul className="lot__actionsList">
									{logButton}
									{this.saleButtons(this.state.data.lot)}
								</ul>
							</div>
						</div>
						<Formik
							enableReinitialize
							validateOnMount={true}
							initialValues={this.state.initial}
							//initialTouched={this.state.initial}
							//initialErrors={this.state.initial}
							validationSchema={this.validation}
							onSubmit={(values) => {
								this.props.loadingStatus(true)
								//return
								let user = userToken()
								let req = superagent
									.post(settings.ep + "/updateLot")
									.field("data", JSON.stringify(values))
									.set("Authorization", user)
								if (_.has(values, `lot.filesToUpload.plan_file`)) {
									req.attach("plan_file", values.lot.filesToUpload.plan_file)
								}
								if (_.has(values, `lot.filesToUpload.hud_doc`)) {
									req.attach("hud_doc", values.lot.filesToUpload.hud_doc)
								}
								req.end((err, data) => {
									this.props.loadingStatus(false)
									toast.success(_.get(data, `body.message`))
									this.setState(
										{
											redirect: true,
											redirectPath: data.redirect,
										},
										() => {
											if (this.props.closeOnSave) {
												this.props.onClose()
												return
											}
											this.props.getPayload()
										}
									)
								})
							}}>
							{(f) => <div className="lot">{this.renderForm(f)}</div>}
						</Formik>
						<Modal
							classNames={{ modal: "modalForm" }}
							open={this.state.bustoutModal}
							onClose={() => this.setState({ bustoutModal: false })}
							center>
							<BustoutModal data={this.state.data} notify={this.notify} name="bustoutModal" />
						</Modal>
						<Modal
							classNames={{ modal: "modalForm" }}
							open={this.state.transferModal}
							onClose={() => this.setState({ transferModal: false })}
							center>
							<TransferModal
								data={this.state.data.lot}
								notify={this.notify}
								name="transferModal"
								super={true}
							/>
						</Modal>
						<Modal
							classNames={{ modal: "modalForm" }}
							open={this.state.closingModal}
							onClose={() => this.setState({ closingModal: false })}
							center>
							<ClosingModal
								data={this.state.data}
								notify={this.notify}
								name="closingModal"
								super={true}
							/>
						</Modal>
						<Modal
							classNames={{ modal: "modalForm" }}
							open={this.state.contractModal}
							onClose={() => this.setState({ contractModal: false })}
							center>
							<ContractModal
								data={this.state.data}
								notify={this.notify}
								name="contractModal"
								super={true}
							/>
						</Modal>
						<Modal
							classNames={{ modal: "modalForm" }}
							open={this.state.moveModal}
							onClose={() => this.setState({ moveModal: false })}
							center>
							<MoveModal data={this.state.data.lot} notify={this.notify} name="moveModal" super={true} />
						</Modal>
						<Modal
							classNames={{ modal: "modalForm" }}
							open={this.state.deleteSale}
							onClose={() => this.setState({ deleteSale: false })}
							center>
							<DeleteSale
								data={this.state.data.lot}
								sale={this.state.deleteSaleDetails}
								notify={this.notify}
								name="deleteSale"
								super={true}
							/>
						</Modal>
						<Modal
							classNames={{ modal: "modalForm" }}
							open={this.state.removeClosing}
							onClose={() => this.setState({ removeClosing: false })}
							center>
							<RemoveClosing
								data={this.state.data.lot}
								sale={this.state.removeClosingData}
								notify={this.notify}
								name="removeClosing"
								super={true}
							/>
						</Modal>
						<Modal
							classNames={{ modal: "modalForm" }}
							open={this.state.removeCancel}
							onClose={() => this.setState({ removeCancel: false })}
							center>
							<RemoveCancel
								data={this.state.data.lot}
								sale={this.state.removeCancelDetails}
								notify={this.notify}
								name="removeCancel"
								super={true}
							/>
						</Modal>
						<Modal
							classNames={{ modal: "modalForm" }}
							open={this.state.logModal}
							onClose={() => this.setState({ logModal: false })}
							center>
							{this.buildLog()}
						</Modal>
						<Modal
							classNames={{ modal: "modalForm mid" }}
							open={this.state.diffViewer}
							onClose={() => this.setState({ diffViewer: false })}
							center>
							{this.diffViewer()}
						</Modal>
					</div>
				</Modal>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(LotModal)
